/* Wolf — Built to Last · shared behaviors (extracted from the homepage prototype 2026-07-28)
   Every block guards for absence so any page can load this file. */
(function(){
  // JS-availability flag lives HERE so a failed script load leaves the page visible (no-js styles)
  document.documentElement.classList.replace("no-js","js");
  var reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- mobile sticky header: solid once the announcement bar has scrolled off ----
     Under 760px the header's section wrapper is position:sticky (site.css). On the home
     template header.nav is a transparent overlay on the hero, so it needs a background the
     moment it is pinned over body copy. html.wolf-hdr-stuck is that flag; site.css keys the
     solid background off it (and off .no-js, so a script failure never leaves a see-through
     header). Sits FIRST in the file, before anything that can throw. Passive + rAF-coalesced;
     the flag flips at --announce-h (37px), the point where the bar has left the viewport. */
  try {
    var hdrStuck = false, hdrTick = false;
    var hdrSync = function () {
      hdrTick = false;
      var s = (window.pageYOffset || document.documentElement.scrollTop || 0) > 37;
      if (s !== hdrStuck) { hdrStuck = s; document.documentElement.classList.toggle('wolf-hdr-stuck', s); }
    };
    var hdrOnScroll = function () { if (!hdrTick) { hdrTick = true; (window.requestAnimationFrame || setTimeout)(hdrSync); } };
    window.addEventListener('scroll', hdrOnScroll, { passive: true });
    hdrSync();
  } catch (hdrErr) {}

  /* ---- imported-description sanitizer (2026-08-03) ----
     Admin/app-authored HTML ({{ product.description }}, article bodies) renders raw --
     platform norm -- but it must NEVER carry this file's behavior hooks or live form
     controls: a class like "hero-video"/"pdp-vrows" or a form="wolf-buy-form" control
     smuggled into copy would hijack media loaders or out-vote the shopper's variant
     pick. Strip both BEFORE any behavior block reads the DOM. Visual cost is nil: the
     description styles key off elements, and our own .d-lead spans are created later.
     Scope: ONLY containers explicitly marked data-import (admin/app-authored HTML:
     product descriptions, article.content, page.content). Theme-authored .a-body
     markup (contact form, guide pull-quotes) must never be sanitized — the unscoped
     '.a-body' selector here deleted the contact form on every load (6g audit). */
  try {
  document.querySelectorAll('.pdp-desc[data-import], .a-body[data-import]').forEach(function (rt) {
    // Containers (form/fieldset/label/button) get UNWRAPPED, not removed: the HTML parser
    // nests every following sibling inside an unclosed <form>, so removeChild(form) would
    // silently delete the rest of the description/article for JS users only (pass-3 find).
    // Leaf controls carry no prose worth keeping and are removed outright.
    rt.querySelectorAll('form,fieldset,label,button').forEach(function (el) {
      if (!el.parentNode) return;
      while (el.firstChild) el.parentNode.insertBefore(el.firstChild, el);
      el.parentNode.removeChild(el);
    });
    rt.querySelectorAll('input,select,textarea,option,model-viewer').forEach(function (el) {
      if (el.parentNode) el.parentNode.removeChild(el);
    });
    rt.querySelectorAll('[class],[form],[name],[id],[data-glb],[data-viewer-src],[data-src-desktop],[data-src-mobile],[data-full],[data-img],[data-price]').forEach(function (el) {
      ['class', 'form', 'name', 'id', 'data-glb', 'data-viewer-src', 'data-src-desktop', 'data-src-mobile', 'data-full', 'data-img', 'data-price'].forEach(function (attr) { el.removeAttribute(attr); });
    });
    /* handler + style attributes on ALLOWLISTED tags are the residual the server-side
       inversion cannot express (Liquid has no character classes). Enumerating attribute
       NAMES here is safe where enumerating them in Liquid was not: this reads the real
       parsed attribute list, so `on` + anything is caught by prefix. */
    rt.querySelectorAll('*').forEach(function (el) {
      Array.prototype.slice.call(el.attributes).forEach(function (at) {
        var n = at.name.toLowerCase();
        if (n.indexOf('on') === 0 || n === 'style' || n === 'srcdoc') el.removeAttribute(at.name);
      });
    });
  });
  /* a sanitizer exception must not kill this IIFE's prologue — everything below
     (reveal wiring, menus, media) still runs; the buy-form guard has its own IIFE.
     It must not be SILENT either: a mid-walk abort leaves later imported nodes
     un-neutralized, and that state has to be visible in the console. */
  } catch (sanErr) { try { console.warn('wolf: import sanitizer aborted mid-walk', sanErr); } catch (e) {} }
  /* Shopify theme editor re-renders a section's DOM on every setting change — the
     load-time IntersectionObserver never sees the new nodes, so .rv content would sit
     at opacity:0 until a full reload. Reveal immediately (no animation) in the editor.
     Registered OUTSIDE the sanitizer try so a sanitizer exception can't skip it.
     Listener is inert outside the editor (Shopify only fires these events there). */
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target) e.target.querySelectorAll('.rv,.stitch,.rise').forEach(function (n) { n.classList.add('in'); });
    document.body.classList.add('loaded');
    /* Re-render replaces the header's <details> with a fresh, unenhanced node. Before this,
       a re-render with the menu OPEN detached the element holding the only reference to the
       scroll lock, so body{overflow:hidden} was stranded with no control that could clear it
       and the page froze silently. Release the lock and re-bind. */
    if (e.target && e.target.querySelector && e.target.querySelector('details.menu-wrap')) {
      /* Release OUR lock only. The previous line here was
         `if (body.style.overflow === 'hidden') body.style.overflow = ''`, which had none of the
         ownership discipline the menu block insists on three lines below its own comment about
         it: a Rebuy or Klaviyo drawer holding the lock got it stripped because the merchant
         edited a header setting. Since v4 the theme's lock is a class it alone owns, so
         releasing it cannot touch anyone else's inline style. */
      document.documentElement.classList.remove('wolf-menu-locked');
      if (typeof window.__wolfBindMenu === 'function') window.__wolfBindMenu();
    }
  });
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target;
    if (!root || !root.querySelectorAll) return;
    if (window.__wolfBindPdpMedia) window.__wolfBindPdpMedia(root);
    if (window.__wolfBindPdpVariants) window.__wolfBindPdpVariants(root);
    if (root.querySelector('#wolf-buy-form,.pdp-gallery,div.sticky-cta,.pdp-closer') && window.__wolfRefreshPdpSticky) window.__wolfRefreshPdpSticky();
  });
  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target;
    if (!root || !root.querySelectorAll) return;
    if (window.__wolfUnbindPdpMedia) window.__wolfUnbindPdpMedia(root);
    if (window.__wolfUnbindPdpVariants) window.__wolfUnbindPdpVariants(root);
    if (root.querySelector('#wolf-buy-form,.pdp-gallery,div.sticky-cta,.pdp-closer') && window.__wolfClearPdpSticky) {
      window.__wolfClearPdpSticky();
      // Unload precedes removal. Rebind surviving sections on the next frame;
      // deleting only the closer must not retire the remaining buy bar.
      requestAnimationFrame(function () {
        if (window.__wolfRefreshPdpSticky) window.__wolfRefreshPdpSticky();
      });
    }
  });
  // media URLs from data-* attributes must be same-origin paths or first-party CDN URLs.
  // "/\host" and "/\/host" resolve to off-origin in WHATWG URL, so backslash is barred
  // alongside "//". On the Shopify theme, asset_url returns cdn.shopify.com URLs, which are
  // explicitly allowed; anything else (attacker-hosted media via a theme-editable attribute)
  // is refused and the poster/fallback stays.
  var SAME_ORIGIN_PATH = /^\/[^/\\]/;
  var mediaUrlOk = function (u) {
    if (!u) return false;
    u = String(u);
    // The WHATWG URL parser strips TAB/CR/LF before parsing, so "/\t/evil.com" passes a
    // path-shape regex yet resolves protocol-relative to evil.com. Bar every whitespace
    // and control character and backslash outright before any shape check.
    if (/[\s\\\u0000-\u001F\u007F]/.test(u)) return false;
    if (SAME_ORIGIN_PATH.test(u)) return true;
    try {
      var p = new URL(u, document.baseURI);
      if (p.protocol !== 'https:') return false;
      return p.host === location.host || p.host === 'cdn.shopify.com';
    } catch (e) { return false; }
  };

  // staged hero rise, once
  document.readyState === 'loading' ? addEventListener('DOMContentLoaded', function(){ document.body.classList.add('loaded'); }) : document.body.classList.add('loaded');

  // one reveal system for everything below the hero
  var revealables = document.querySelectorAll('.rv,.stitch');
  var io = null;
  if('IntersectionObserver' in window){
    // Dual reveal test: ratio .22 alone is unreachable for any element taller than
    // viewport/.22 (a long article body would stay opacity:0 forever), so tall elements
    // also reveal once .22 of the VIEWPORT is covered. Fine-grained thresholds so the
    // callback actually fires while the ratio is still small.
    var revealSteps = [0.0005, 0.001, 0.002, 0.005];
    for(var ti=0; ti<=22; ti++) revealSteps.push(ti/100);
    /* sub-1% steps: an element taller than 100 viewports never crosses 0.01, so
       without them the 22%-of-viewport test would have no callback to run in */
    io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(!e.isIntersecting) return;
        var vh = window.innerHeight || document.documentElement.clientHeight;
        if(e.intersectionRatio < .22 && e.intersectionRect.height < vh * .22) return;
        e.target.classList.add('in');
        if(e.target.hasAttribute('data-stats')) runCounters(e.target);
        io.unobserve(e.target);
      });
    }, {threshold:revealSteps});
    revealables.forEach(function(el){ io.observe(el); });
  } else {
    revealables.forEach(function(el){ el.classList.add('in'); });
  }

  // settling counters (one-shot, ease-out like a scale coming to rest)
  var proof = document.querySelector('.proof');
  if(proof){
    proof.setAttribute('data-stats','');
    if(io){ io.observe(proof); } else { runCounters(proof); }
  }
  function runCounters(scope){
    scope.querySelectorAll('[data-count]').forEach(function(el){
      // markup ships the real value (no-JS/crawler safe); JS only animates the settle
      var target = +el.getAttribute('data-count'), suffix = el.getAttribute('data-suffix')||'';
      if(reduced || target === 0){ el.textContent = target.toLocaleString('en-US') + suffix; return; }
      var t0 = null, DUR = 950;
      function step(ts){
        if(!t0) t0 = ts;
        var p = Math.min((ts - t0)/DUR, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = Math.round(target * eased).toLocaleString('en-US') + (p === 1 ? suffix : '');
        if(p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    });
  }

  // trust flip-through — operator-requested continuous flip; pauses off-viewport, static under reduced motion
  var flip = document.querySelector('.flip');
  if(flip){
    var words = [].slice.call(flip.children), idx = 0, timer = null;
    var flipMq = matchMedia('(prefers-reduced-motion: reduce)');
    var haltFlip = function(){
      if(timer){ clearTimeout(timer); timer = null; }
      words.forEach(function(w){ w.classList.remove('on','out'); });
      idx = words.length - 1;
      words[idx].classList.add('on');
    };
    var onFlipMq = function(m){ if(m.matches) haltFlip(); };
    if(flipMq.addEventListener){ flipMq.addEventListener('change', onFlipMq); } else if(flipMq.addListener){ flipMq.addListener(onFlipMq); }
    if(reduced){
      words[words.length-1].classList.add('on');
    } else {
      words[0].classList.add('on');
      var advance = function(){
        var prev = words[(idx + words.length - 1) % words.length],
            cur  = words[idx],
            next = words[(idx + 1) % words.length];
        prev.classList.remove('out');
        cur.classList.remove('on'); cur.classList.add('out');
        next.classList.add('on');
        idx = (idx + 1) % words.length;
      };
      // cadence: open fast through toughest/bravest, then hold on "best." before restarting
      var FLIP_FAST = 1400, FLIP_HOLD = 6000;
      var tick = function(){
        timer = setTimeout(function(){
          advance();
          tick();
        }, idx === words.length - 1 ? FLIP_HOLD : FLIP_FAST);
      };
      if('IntersectionObserver' in window){
        new IntersectionObserver(function(entries){
          entries.forEach(function(e){
            if(e.isIntersecting && !timer && !flipMq.matches){ tick(); }
            else if(!e.isIntersecting && timer){ clearTimeout(timer); timer = null; }
          });
        }).observe(flip);
      } else {
        tick();
      }
    }
  }

  // review river — continuous marquee: duplicate the set for a seamless -50% loop,
  // pause off-viewport; hover/focus pause and reduced-motion handled in CSS
  document.querySelectorAll('.voc-carousel .voc-track').forEach(function(track){
    var cards = [].slice.call(track.children);
    if(!cards.length) return;
    cards.forEach(function(c){ c.classList.remove('rv','d1','d2','d3','d4'); });
    cards.forEach(function(c){
      var d = c.cloneNode(true);
      d.setAttribute('aria-hidden','true');
      track.appendChild(d);
    });
    /* speed is PER CARD so a longer river never scrolls faster; mobile shows one
       ~85vw card at a time, so it gets more read-time per card than desktop */
    var riverMq = matchMedia('(max-width: 760px)');
    var setRiverDur = function(){ track.style.animationDuration = (cards.length * (riverMq.matches ? 12 : 7)) + 's'; };
    setRiverDur();
    if (riverMq.addEventListener) { riverMq.addEventListener('change', setRiverDur); } else if (riverMq.addListener) { riverMq.addListener(setRiverDur); }
    if(!reduced && 'IntersectionObserver' in window){
      new IntersectionObserver(function(entries){
        entries.forEach(function(e){ track.style.animationPlayState = e.isIntersecting ? 'running' : 'paused'; });
      }).observe(track.parentNode);
    }
    /* explicit pause control — touch has no hover to pause with (WCAG 2.2.2); same
       pattern as the quote rotor's .qr-pause below. The class out-ranks the IO's
       inline play-state via CSS; reduced motion hides the button in CSS (the river
       is already static there). */
    if(!reduced){
      var rvUser = false;
      var rvBtn = document.createElement('button');
      rvBtn.type = 'button';
      rvBtn.className = 'qr-pause voc-pause';
      var rvLabel = function(){
        /* label swap carries the state — pairing it with aria-pressed reads as
           "Play reviews, pressed" to AT (double-negative toggle; review pass-2) */
        rvBtn.textContent = rvUser ? 'Play reviews' : 'Pause reviews';
      };
      rvLabel();
      rvBtn.addEventListener('click', function(){
        rvUser = !rvUser;
        track.classList.toggle('voc-user-paused', rvUser);
        rvLabel();
      });
      track.parentNode.insertAdjacentElement('afterend', rvBtn);
    }
  });

  /* mobile menu — ENHANCEMENT ONLY.
     The open/close is native <details>; nothing below is required for the menu to work.
     Each piece degrades to a usable state if site.js never runs: no scroll lock (page
     scrolls behind the overlay), no Escape (tap "Close"), no focus move (tab order is
     already correct because the panel follows the summary in the DOM). */
  /* Exposed so shopify:section:load can re-bind after the header is re-rendered — listeners
     attached to a detached node are worse than no listeners, because the scroll lock they
     own becomes unreleasable. Idempotent: it re-queries and re-attaches to whatever is in
     the document now. */
  /* A WeakSet of nodes, not a data- attribute. `dataset.wolfBound` recorded that an ATTRIBUTE
     survived, which is not the same fact as "this node has listeners": a clone or a
     serialize/reparse in the theme editor carries attributes forward and drops listeners, so
     the guard saw its own marker on a fresh unenhanced node and returned — leaving a menu with
     no scroll lock, no Escape and no close-on-navigate, permanently. Node identity is the thing
     listeners actually attach to, so key the guard on identity. A clone is a different object
     and binds correctly; the same node short-circuits, which is exactly right because its
     listeners really did survive. WeakSet so detached headers can be collected. */
  var boundMenus = new WeakSet();
  window.__wolfBindMenu = function(){
  // element-qualified per this file's convention: raw page/article content can wear a class
  var menuWrap = document.querySelector('details.menu-wrap'),
      panel = document.getElementById('menu-panel');
  if(menuWrap && panel){
    if(boundMenus.has(menuWrap)) return;   // never double-bind
    boundMenus.add(menuWrap);
    var menuBtn = menuWrap.querySelector('summary');
    /* Scroll lock, take four — and the first three all failed for ONE reason.
       v1 (`overflow = open ? 'hidden' : ''`) clobbered another overlay's lock.
       v2 saved the previous value and restored it, stranding the lock permanently: app locks →
       menu opens and saves 'hidden' → app closes and writes '' → menu closes and restores its
       saved 'hidden'. Nothing open, page frozen.
       v3 claimed the lock only when nobody held it. Three reviewers broke it independently:
         · menu opens (claims) → app opens → menu closes → we write '' → the APP's overlay is
           open with the page scrolling behind it;
         · app opens → menu opens (declines to claim) → app closes and writes '' → the FULL
           SCREEN MENU is open with the page scrolling behind it;
         · app had 'auto'/'scroll' inline → we overwrite with 'hidden' → we restore '', not what
           was there.
       The invariant every version violated: `document.body.style.overflow` is ONE slot with no
       refcount, and independent writers cannot establish ownership by reading its current
       value. Saving it isn't ownership; testing it isn't ownership; there is no ownership.
       v4 stops competing for the slot. We add a class we alone own and let an `!important`
       stylesheet rule win while it is present. A stylesheet !important beats an app's inline
       style, so our lock holds even under an app that writes ''; removing the class hands
       control straight back to whatever inline value the app still has, untouched. Every
       interleaving above resolves, because we never write to the shared property at all.
       No-JS behaviour is unchanged: no class, no lock, page scrolls behind the panel — exactly
       what the disclosure contract already promises. */
    var lock = function(){ document.documentElement.classList.add('wolf-menu-locked'); };
    var unlock = function(){ document.documentElement.classList.remove('wolf-menu-locked'); };
    var close = function(focusBtn){
      menuWrap.open = false;                       // fires 'toggle', which unlocks scroll
      if(focusBtn && menuBtn) menuBtn.focus();
    };
    /* Sync, not just react. site.js runs late on a throttled phone (~7.7s measured) and the
       menu opens natively long before that — no toggle event ever reaches a listener attached
       afterwards, so the shopper got an open menu with no scroll lock and no focus move until
       they closed and reopened it. That is precisely the delayed-JS case this refactor exists
       for, so it has to be handled, not assumed away. */
    /* THIS IS A DISCLOSURE, NOT A MODAL — and it now says so consistently.
       An earlier version set role="dialog"/aria-modal="true" at runtime and ran a Tab trap.
       Both were wrong together: aria-modal was on #menu-panel while the only close control
       (the <summary>) is its SIBLING, so assistive tech honouring the modal removed the one
       affordance that closes it; and aria-modal without `inert` hides the background from
       screen readers while leaving it live for everyone else. Enforcing a real modal means
       inerting the page and owning every restore path — more machinery than a nav panel
       earns, and it cannot work in the no-JS state this component exists to support.
       So: a labelled <nav> disclosure, identical with and without JS. Focus moves in on open
       and back on close because that is useful and honest; nothing claims containment in
       ARIA. Tab does wrap within the open panel at mobile widths (document-level listener
       below) — a keyboard courtesy over a full-screen surface, not an enforced modal:
       nothing is hidden from anyone and closing still never depends on JS. */
    var sync = function(moveFocus){
      if(menuWrap.open){
        /* Above the nav-collapse cut (1200px, same as site.css) the disclosure is
           display:none — locking there freezes a page with no visible close control
           (a programmatic open via extension/app script lands here; onWide only covers
           load-time and width-CHANGE events). Close it outright: leaving it open-but-unlocked
           hands a later shrink an open menu with no lock.
           Same focus discipline as onWide: never strand focus in a hidden subtree. */
        if(!menuMq.matches){
          var wideActive = document.activeElement;
          menuWrap.open = false;
          if(wideActive && menuWrap.contains(wideActive) && wideActive.blur) wideActive.blur();
          unlock(); return;
        }
        lock();
        if(moveFocus){ var first = panel.querySelector('a'); if(first) first.focus(); }
      } else {
        unlock();
      }
    };
    menuWrap.addEventListener('toggle', function(){ sync(true); });
    sync(false);   // adopt an already-open menu without stealing focus from the shopper
    /* Key off the SAME predicate the CSS uses (max-width:1200px). Watch that query and
       close when it stops matching — one source of truth, no gap to land in. */
    /* Applied IMMEDIATELY, not only on future `change` events. A <details open> restored by the
       browser, cloned by the editor, or authored in markup, on a page that LOADS wide, never
       fires a change event — sync(false) locked the page and nothing on a desktop viewport
       could unlock it, because the disclosure that closes it is display:none above 1200px. */
    onWide(menuMq);
    panel.querySelectorAll('a').forEach(function(a){ a.addEventListener('click', function(){
      var href = a.getAttribute('href') || '';
      if(href.charAt(0) !== '#'){ close(false); return; }
      close(false);
      // a fragment is not necessarily a valid CSS selector — href="#" is a normal Shopify
      // "header" menu item and threw SyntaxError out of this handler
      var target = null;
      try { target = document.getElementById(decodeURIComponent(href.slice(1))); } catch(err){}
      if(target){ target.setAttribute('tabindex','-1'); target.focus({preventScroll:true}); }
    }); });
  }
  };
  /* DOCUMENT-level listeners are registered ONCE, outside the per-element binder, and look the
     live menu up at event time. Registering them inside meant one new window keydown listener
     and one new MediaQueryList listener per shopify:section:load — each closing over a DETACHED
     header, so after N edits in the theme editor every Escape ran N stale handlers, the first of
     which called focus() on a detached <summary> and dropped activeElement to <body>. Nothing
     ever removed them because neither `window` nor the mq object is replaced by a re-render. */
  var liveMenu = function(){
    var w = document.querySelector('details.menu-wrap');
    return (w && document.getElementById('menu-panel')) ? w : null;
  };
  addEventListener('keydown', function(e){
    if(e.key !== 'Escape') return;
    var w = liveMenu();
    if(w && w.open){ w.open = false; var s = w.querySelector('summary'); if(s) s.focus(); }
  });
  var menuMq = matchMedia('(max-width: 1200px)');
  var onWide = function(m){
    var w = liveMenu();
    if(m.matches || !w || !w.open) return;
    /* Close focus-aware: above 1200px the <summary> is display:none, so focusing it is a no-op
       and focus would be stranded on a link inside a now-hidden panel — no visible focus ring
       and keyboard navigation resuming from an invisible subtree. Drop to body explicitly. */
    var active = document.activeElement;
    w.open = false;
    if(active && w.contains(active) && active.blur) active.blur();
  };
  if(menuMq.addEventListener){ menuMq.addEventListener('change', onWide); } else if(menuMq.addListener){ menuMq.addListener(onWide); }
  /* Tab containment while the panel is open at mobile widths. The panel is full-screen
     ≤1200px, so Tab walking out of it lands on content the shopper cannot see; wrap
     between the summary (the close control) and the panel's last focusable instead.
     Deliberately NOT a modal (see the disclosure comment above): no aria-modal, no
     inert, no role=dialog — Escape and no-JS behavior are untouched. Document-level
     like the Escape handler, so section re-renders never stack stale copies. */
  addEventListener('keydown', function(e){
    if(e.key !== 'Tab') return;
    var w = liveMenu();
    if(!w || !w.open || !menuMq.matches || !w.contains(e.target)) return;
    var items = [].filter.call(w.querySelectorAll('summary, a[href], input, button, select, textarea, [tabindex]'), function(el){
      if (el.getAttribute && el.getAttribute('tabindex') === '-1') return false;
      if (el.closest && el.closest('[aria-hidden="true"]')) return false;
      return !el.disabled && el.getClientRects().length;
    });
    if(!items.length) return;
    var first = items[0], last = items[items.length - 1];
    if(e.shiftKey && e.target === first){ e.preventDefault(); last.focus(); }
    else if(!e.shiftKey && e.target === last){ e.preventDefault(); first.focus(); }
  });
  window.__wolfBindMenu();

  /* Cross-sell variant picker — ENHANCEMENT ONLY. The <details> dropdown and its radios work
     with zero JS (that is why it is not a <select>); this just writes the chosen label into the
     closed control and shuts the panel, which is the one thing CSS cannot do. Delegated, so
     cards added by a section re-render are covered without rebinding. */
  /* Set when a pick came from arrow-key traversal inside an open picker — read by the
     change handler below so keyboard walking doesn't close the panel. Holds the ORIGIN
     input (not a bare bool) and self-clears on the same tick: an Arrow press that never
     produces a `change` (last enabled radio, cancelled default) must not leave a stale
     flag that swallows the next POINTER selection, in this or any other picker (pass-5). */
  /* Keyboard dismissal for the card picker (pass-5): native <details> ignores Escape,
     and .cvp[open] .cvp-panel is absolutely positioned OVER the card's Add to Cart
     button — an open panel left behind hides the next focus stop (WCAG 2.4.11).
     Escape closes and returns focus to the summary; focus leaving the picker closes it. */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' && e.key !== 'Esc') return;
    var t = e.target;
    var pk = t && t.closest && t.closest('details[data-wolf-picker][open]');
    if (!pk) return;
    pk.open = false;
    var sm = pk.querySelector('summary');
    if (sm) sm.focus();
  });
  /* Pointer selection guard (audit F-4, 2026-09-02): a pointerdown on a non-focusable
     <label> blurs the focused summary with relatedTarget=null BEFORE the click lands, so
     the focusout below closed the panel and the click never reached the radio — mouse and
     touch picks silently did nothing. Remember which picker a pointer went down inside;
     that picker's next blur is not "focus left", it is the pick in progress. Cleared on
     pointerup/cancel (next tick, after the click) so a stale flag can't mask a real blur. */
  var wolfPickerPointer = null;
  var wolfPickerPointerClear = function () {
    setTimeout(function () { wolfPickerPointer = null; }, 0);
  };
  document.addEventListener('pointerdown', function (e) {
    var t = e.target;
    wolfPickerPointer = (t && t.closest) ? t.closest('details[data-wolf-picker][open]') : null;
    /* pointer outside every open picker closes them — focusout alone misses the case
       where the summary already lost focus to an aborted press inside the panel */
    Array.prototype.forEach.call(document.querySelectorAll('details[data-wolf-picker][open]'), function (op) {
      if (op !== wolfPickerPointer) op.open = false;
    });
  }, true);
  document.addEventListener('pointerup', wolfPickerPointerClear, true);
  document.addEventListener('pointercancel', wolfPickerPointerClear, true);
  document.addEventListener('focusout', function (e) {
    var pk = e.target && e.target.closest && e.target.closest('details[data-wolf-picker][open]');
    if (!pk) return;
    /* relatedTarget is the element gaining focus — null on blur-to-nothing */
    var to = e.relatedTarget;
    if (to && pk.contains(to)) return;
    if (wolfPickerPointer === pk) return;
    /* defer, then re-check: a browser that sets relatedTarget late (or moves focus into
       the panel on the same tick) must not have its pick cut off */
    setTimeout(function () {
      if (!pk.open) return;
      var ae = document.activeElement;
      if (ae && pk.contains(ae)) return;
      if (wolfPickerPointer === pk) return;
      pk.open = false;
    }, 0);
  });

  var wolfArrowPick = null;
  document.addEventListener('keydown', function (e) {
    if (!/^(Arrow|Home|End|PageUp|PageDown)/.test(e.key)) return;
    var t = e.target;
    if (!t || t.type !== 'radio' || !t.closest) return;
    /* track the PICKER, not the origin radio: `change` fires on the NEWLY checked
       radio, so comparing against the origin input never matches and the guard is
       dead (pass-5 — this exact mistake reverted the pass-4 fix once already). */
    var pk = t.closest('details[data-wolf-picker][open]');
    if (!pk) return;
    wolfArrowPick = pk;
    setTimeout(function () { if (wolfArrowPick === pk) wolfArrowPick = null; }, 0);
  }, true);
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || input.type !== 'radio' || input.name !== 'id') return;
    var picker = input.closest && input.closest('details[data-wolf-picker]');
    if (!picker) return;
    var label = picker.querySelector('[data-wolf-picker-label]');
    var text = input.parentElement && input.parentElement.querySelector('.cvp-opt-t');
    /* same "Key: value" shape Liquid rendered for the pre-checked default, so the closed
       control always names the variant the form will post */
    var key = picker.getAttribute('data-wolf-picker-key') || '';
    var shown = text ? (key ? key + ': ' : '') + text.textContent : '';
    // Keep long bundle option keys in the accessible name, so the visible value is not clipped.
    if (label && text) label.textContent = text.textContent;
    /* the summary's aria-label must follow the pick too, and focus returns to the summary
       before the panel hides the focused radio (focus stranded in hidden content otherwise) */
    var summ = picker.querySelector('summary');
    if (summ && text) {
      var pn = picker.getAttribute('data-wolf-picker-name');
      summ.setAttribute('aria-label', shown + ', change option' + (pn ? ' for ' + pn : ''));
    }
    /* Close+refocus only for POINTER selection. On keyboard, arrow keys move between
       radios and fire `change` per step — closing there truncated traversal at option 2
       (pass-4). `change` carries no usable detail, so the gesture is tracked at source.
       Keyboard dismissal is provided explicitly below (Escape + focusout): native
       <details> does NOT close on Escape, and the open panel overlays the card's Add to
       Cart button, so leaving it open would obscure the next focus stop (pass-5). */
    if (wolfArrowPick !== picker) {
      picker.open = false;
      if (summ) summ.focus();
    }
    wolfArrowPick = null;
  });

  // prototype email capture: honest note, no fake success.
  // Only intercept the PROTOTYPE form (no action attribute). The Shopify theme's Pack form
  // posts through {% form 'customer' %} and must actually submit.
  var form = document.querySelector('.pack form');
  if(form && !form.getAttribute('action')){
    form.addEventListener('submit', function(ev){
      ev.preventDefault();
      var email = form.querySelector('input[type="email"]'),
          note = document.querySelector('[data-note]');
      if(!email.checkValidity()){ note.textContent = 'enter a valid email address'; email.focus(); return; }
      note.textContent = 'prototype build — signup wires to Klaviyo on the Shopify port';
    });
  }

  // ---------- PDP gallery: thumbs swap the main photo; main photo zooms to inspect ----------
  var pdpGalleryBindings = new WeakMap();
  window.__wolfBindPdpMedia = function (root) {
    root.querySelectorAll('.pdp-gallery').forEach(function (gal) {
      if (pdpGalleryBindings.has(gal)) return;
      var cleanups = [];
      function listen(target, type, handler, options) {
        target.addEventListener(type, handler, options);
        cleanups.push(function () { target.removeEventListener(type, handler, options); });
      }
      pdpGalleryBindings.set(gal, function () {
        cleanups.forEach(function (cleanup) { cleanup(); });
        pdpGalleryBindings.delete(gal);
      });
    var main = gal.querySelector('.g-main');
    var mainImg = main && main.querySelector('img');
    gal.querySelectorAll('.g-thumbs button').forEach(function(btn){
      var ti = btn.querySelector('img');
      if (ti) btn.setAttribute('aria-label', 'View photo: ' + ti.alt);
      listen(btn, 'click', function(){
        var t = btn.querySelector('img');
        if (!t || !mainImg) return;
        /* the Liquid-emitted responsive srcset stays authoritative over a bare src swap —
           the browser keeps showing the OLD candidate. Drop it (and sizes) on swap. */
        mainImg.removeAttribute('srcset'); mainImg.removeAttribute('sizes');
        mainImg.src = btn.getAttribute('data-full') || t.src;
        mainImg.alt = t.alt;
        if (typeof setMainLabel === 'function') setMainLabel();
        main.classList.remove('zoomed');
        main.setAttribute('aria-pressed','false');
        mainImg.style.transformOrigin = '50% 50%';
        gal.querySelectorAll('.g-thumbs button').forEach(function(b){ b.removeAttribute('aria-current'); });
        btn.setAttribute('aria-current','true');
      });
    });
    /* thumb rail (spoke pdp-polish): keep the aria-current thumb in view whoever sets it —
       a thumb click, the variant picker (applyControl, below) or the bundle builder's
       swapImage. Scrolls the RAIL only (never the page), and only when the thumb is out of
       the rail's viewport. Left/Right arrows move focus along the rail. */
    var rail = gal.querySelector('.g-thumbs--rail');
    if (rail) {
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var revealCurrent = function () {
        var cur = rail.querySelector('button[aria-current="true"]');
        if (!cur) return;
        var left = cur.getBoundingClientRect().left - rail.getBoundingClientRect().left + rail.scrollLeft, right = left + cur.offsetWidth;
        var vis0 = rail.scrollLeft, vis1 = vis0 + rail.clientWidth;
        if (left >= vis0 && right <= vis1) return;
        var target = Math.max(0, left - (rail.clientWidth - cur.offsetWidth) / 2);
        if (reduce || !rail.scrollTo) rail.scrollLeft = target;
        else rail.scrollTo({ left: target, behavior: 'smooth' });
      };
      revealCurrent();
      if ('MutationObserver' in window) {
        var railObserver = new MutationObserver(revealCurrent);
        railObserver.observe(rail, { attributes: true, attributeFilter: ['aria-current'], subtree: true });
        cleanups.push(function () { railObserver.disconnect(); });
      }
      listen(rail, 'keydown', function (e) {
        if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
        var btns = Array.prototype.slice.call(rail.querySelectorAll('button'));
        var i = btns.indexOf(document.activeElement);
        if (i < 0) return;
        e.preventDefault();
        var next = btns[e.key === 'ArrowRight' ? Math.min(btns.length - 1, i + 1) : Math.max(0, i - 1)];
        next.focus();
      });
    }
    if (main && mainImg) {
      main.setAttribute('role','button');
      main.setAttribute('tabindex','0');
      main.setAttribute('aria-pressed','false');
      var setMainLabel=function(){ main.setAttribute('aria-label','Zoom to inspect: ' + mainImg.alt + '. When zoomed, arrow keys or pointer movement pan the image.'); };
      setMainLabel();
      var setOrigin = function(e){
        var r = main.getBoundingClientRect();
        var x = ((e.touches ? e.touches[0].clientX : e.clientX) - r.left) / r.width * 100;
        var y = ((e.touches ? e.touches[0].clientY : e.clientY) - r.top) / r.height * 100;
        mainImg.style.transformOrigin = Math.max(0,Math.min(100,x)) + '% ' + Math.max(0,Math.min(100,y)) + '%';
      };
      var toggleZoom = function(e){
        var on = main.classList.toggle('zoomed');
        main.setAttribute('aria-pressed', String(on));
        // Zoom uses the existing full-resolution source; small responsive candidates are for the initial view.
        if (on) { mainImg.removeAttribute('srcset'); mainImg.removeAttribute('sizes'); }
        if (on && e && (e.clientX || e.touches)) setOrigin(e);
        if (!on) mainImg.style.transformOrigin = '50% 50%';
      };
      listen(main, 'click', toggleZoom);
      listen(main, 'keydown', function(e){
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggleZoom(); return; }
        if (!main.classList.contains('zoomed')) return;
        var deltas = {ArrowLeft:[-10,0], ArrowRight:[10,0], ArrowUp:[0,-10], ArrowDown:[0,10]};
        if (deltas[e.key]) {
          e.preventDefault();
          var cur = (mainImg.style.transformOrigin || '50% 50%').split(' ').map(parseFloat);
          var nx = Math.max(0, Math.min(100, cur[0] + deltas[e.key][0]));
          var ny = Math.max(0, Math.min(100, cur[1] + deltas[e.key][1]));
          mainImg.style.transformOrigin = nx + '% ' + ny + '%';
        }
      });
      listen(main, 'mousemove', function(e){ if (main.classList.contains('zoomed')) setOrigin(e); });
      listen(main, 'touchmove', function(e){ if (main.classList.contains('zoomed')) { setOrigin(e); e.preventDefault(); } }, {passive:false});
      listen(document, 'keydown', function(e){ if (e.key === 'Escape' && main.classList.contains('zoomed')) toggleZoom(); });
    }
    });
  };
  window.__wolfUnbindPdpMedia = function (root) {
    root.querySelectorAll('.pdp-gallery').forEach(function (gal) {
      var cleanup = pdpGalleryBindings.get(gal);
      if (cleanup) cleanup();
    });
  };
  window.__wolfBindPdpMedia(document);

  /* ---- interactive 3D: one shared module, GLB bytes only on activation ----
     Both homepage launch buttons open dialogs. The previous loader listened only
     for a click on the hidden flagship <model-viewer>, so neither launch button
     actually started the module or GLB request. Keep the loader generic but expose
     only an arming function; product-description markup cannot self-activate. */
  var modelViewerModulePromise = null;
  var loadModelViewerModule = function (viewerSrc) {
    if (customElements.get('model-viewer')) return Promise.resolve();
    if (modelViewerModulePromise) return modelViewerModulePromise;
    modelViewerModulePromise = new Promise(function (resolve, reject) {
      var loader = document.createElement('script');
      loader.type = 'module';
      loader.src = viewerSrc;
      loader.setAttribute('data-wolf-model-viewer-loader', '');
      loader.onerror = function () { reject(new Error('3D module failed to load')); };
      loader.onload = function () {
        var settled = false;
        var defTimer = setTimeout(function () {
          if (!settled) reject(new Error('3D component was not defined'));
        }, 10000);
        customElements.whenDefined('model-viewer').then(function () {
          settled = true;
          clearTimeout(defTimer);
          resolve();
        });
      };
      document.head.appendChild(loader);
    });
    return modelViewerModulePromise;
  };
  var arm3d = function (mv3d) {
    if (!mv3d || mv3d.hasAttribute('data-3d-dead') || mv3d.hasAttribute('data-3d-arming')) return;
    var mark3dActive = function () {
      var thumbBox = mv3d.parentElement && mv3d.parentElement.querySelector('[data-flag-thumbs]');
      if (thumbBox) thumbBox.querySelectorAll('.flag-thumb').forEach(function (button) {
        button.classList.remove('is-on');
        button.setAttribute('aria-pressed', 'false');
      });
      mv3d.setAttribute('aria-label', mv3d.getAttribute('alt') || 'Interactive 3D model');
    };
    if (mv3d.getAttribute('src')) {
      if (typeof mv3d.dismissPoster === 'function') mv3d.dismissPoster();
      mark3dActive();
      return;
    }
    var status3d = mv3d.parentElement && mv3d.parentElement.querySelector('.wolf-3d-status');
    var fail3d = function () {
      mv3d.removeAttribute('data-3d-arming');
      mv3d.setAttribute('data-3d-dead', '');
      if (status3d) { status3d.hidden = false; status3d.textContent = '3D view unavailable. Please use the product photos.'; }
    };
    mv3d.setAttribute('data-3d-arming', '');
    if (status3d) { status3d.hidden = false; status3d.textContent = 'Loading interactive model…'; }
    var glb = mv3d.getAttribute('data-glb') || '';
    var viewerSrc = mv3d.getAttribute('data-viewer-src') || '/assets/vendor/model-viewer.min.js';
    if (!mediaUrlOk(glb) || !mediaUrlOk(viewerSrc) || !('customElements' in window) ||
        !('noModule' in HTMLScriptElement.prototype) || typeof Promise === 'undefined') { fail3d(); return; }
    loadModelViewerModule(viewerSrc).then(function () {
      mv3d.addEventListener('error', fail3d, { once: true });
      mv3d.addEventListener('load', function () {
        mv3d.removeAttribute('data-3d-arming');
        mv3d.setAttribute('data-3d-ready', '');
        mark3dActive();
        if (status3d) status3d.hidden = true;
      }, { once: true });
      mv3d.setAttribute('src', glb);
    }).catch(fail3d);
  };
  window.wolfArm3d = arm3d;

  // Direct activation remains as a fallback; dialog launch buttons call the same
  // function before opening via the homepage-v2 handler near the end of this file.
  var flagship3d = document.querySelector('#flagship model-viewer[data-glb]');
  if (flagship3d) {
    flagship3d.addEventListener('click', function () { arm3d(flagship3d); });
    flagship3d.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); arm3d(flagship3d); }
    });
  }

  /* ---- quote rotor: one review at a time, next drops in every 6s ----
     Layout is a CSS grid stack (container = tallest quote at the CURRENT width,
     so resize/font-swap can never clip). Pauses on hover/focus/tab-hide and via
     an explicit button (touch + keyboard). Reduced motion — at load or enabled
     mid-session — collapses back to the stacked list. */
  var rotor = document.querySelector('div.quote-rotor');
  if (rotor) {
    var qrItems = rotor.querySelectorAll('.qr-item');
    var rotorMq = matchMedia('(prefers-reduced-motion: reduce)');
    if (qrItems.length > 1 && !rotorMq.matches) {
      rotor.classList.add('rotating');
      rotor.setAttribute('aria-label', 'Customer reviews');
      var qrIdx = 0;
      qrItems[0].classList.add('active');
      var qrNext = function () {
        qrItems[qrIdx].classList.remove('active');
        qrIdx = (qrIdx + 1) % qrItems.length;
        qrItems[qrIdx].classList.add('active');
      };
      var qrTimer = null, qrHover = false, qrFocus = false, qrUser = false;
      var qrSync = function () {
        var run = !qrHover && !qrFocus && !qrUser && !document.hidden && !rotorMq.matches && rotor.classList.contains('rotating');
        if (run && !qrTimer) qrTimer = setInterval(qrNext, 6000);
        else if (!run && qrTimer) { clearInterval(qrTimer); qrTimer = null; }
      };
      rotor.addEventListener('mouseenter', function () { qrHover = true; qrSync(); });
      rotor.addEventListener('mouseleave', function () { qrHover = false; qrSync(); });
      rotor.addEventListener('focusin', function () { qrFocus = true; qrSync(); });
      rotor.addEventListener('focusout', function () { qrFocus = false; qrSync(); });
      document.addEventListener('visibilitychange', qrSync);
      var qrBtn = document.createElement('button');
      qrBtn.type = 'button';
      qrBtn.className = 'qr-pause';
      var qrLabel = function () {
        /* single-signal convention shared with the voc river pause (pass-3): the label
           swap carries the state; aria-pressed on a swapped label double-negates */
        qrBtn.textContent = qrUser ? 'Play reviews' : 'Pause reviews';
      };
      qrLabel();
      qrBtn.addEventListener('click', function () { qrUser = !qrUser; qrLabel(); qrSync(); });
      rotor.insertAdjacentElement('afterend', qrBtn);
      var onRotorMq = function (m) {
        if (m.matches) { rotor.classList.remove('rotating'); qrBtn.style.display = 'none'; }
        else { rotor.classList.add('rotating'); qrBtn.style.display = ''; }
        qrSync();
      };
      if (rotorMq.addEventListener) { rotorMq.addEventListener('change', onRotorMq); } else if (rotorMq.addListener) { rotorMq.addListener(onRotorMq); }
      qrSync();
    }
  }

  /* ---- Shop All dropdown: Escape dismisses (WCAG 1.4.13); open/close itself is pure CSS ---- */
  document.querySelectorAll('.nav-drop').forEach(function (li) {
    li.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var trigger = li.querySelector(':scope > a');
      if (trigger) trigger.focus();
      li.classList.add('drop-off');
      e.preventDefault();
    });
    li.addEventListener('mouseleave', function () { li.classList.remove('drop-off'); });
    li.addEventListener('focusout', function () { li.classList.remove('drop-off'); });
  });

  /* ---- sticky mobile CTA: reveal only after the opener scrolls out of view ----
     Hide-by-default is armed HERE, not by the global .js flag, so an exception
     anywhere else in this file leaves the bar visible (fail-open). Pages without
     a #top opener keep the always-visible CSS default. */
  /* Window (audit F-9 + mobile-visual #5, 2026-09-02): the bar is a fixed control that
     acts on ONE product, so it is shown only while the page is "about" that product:
       start — on product templates, once the real buy box (.pdp-cta / #wolf-buy-form)
               has scrolled out above; a bar live at scrollY 0 submitted a size the
               shopper had not seen yet. Elsewhere the #top opener, as before.
       end   — a data-wolf-sticky-until="<selector>" boundary if the bar names one, else
               on non-product pages the LAST card row that links to the bar's product
               (fallback: the last card row), else the anchor an in-page CTA points at.
               Past it the page is selling something else (belts, FAQ, newsletter) and a
               tap adds the wrong product. Product pages have no end by default: every
               section on them is about that product.
     Directional rects (bottom <= 0), not a bare "not intersecting", so an element still
     BELOW the fold counts as not yet reached. Cheap: three rects per scroll frame. */
  /* Product templates (spoke buybox-polish, audit F4 + F1, 2026-09-02): ONE behaviour on
     every PDP template. start = the buy box's primary button itself (not the whole form,
     which on the vest page wraps the picker and loadouts too), so the bar appears the
     moment the red button has scrolled off above and goes away as soon as it is back;
     end = the footer / newsletter zone (a data-wolf-sticky-until override still wins).
     The same frame also marks the closer (.pdp-closer) while the buy-box button is on
     screen on desktop, so two red CTAs are never in one viewport. */
  var clearPdpSticky = function () {};
  window.__wolfClearPdpSticky = function () { clearPdpSticky(); };
  window.__wolfRefreshPdpSticky = function () {
    clearPdpSticky();
    var cleanups = [], alive = true, closerFrame = null, stickyFrame = null;
    function listen(target, type, handler, options) {
      target.addEventListener(type, handler, options);
      cleanups.push(function () { target.removeEventListener(type, handler, options); });
    }
    clearPdpSticky = function () {
      alive = false;
      cleanups.forEach(function (cleanup) { cleanup(); });
      if (closerFrame !== null) cancelAnimationFrame(closerFrame);
      if (stickyFrame !== null) cancelAnimationFrame(stickyFrame);
      if (stickyBar) stickyBar.classList.remove('show');
      if (pdpCloser) pdpCloser.classList.remove('is-dup');
    };
  var pdpBuyForm = document.getElementById('wolf-buy-form');
  var pdpPrimaryCta = pdpBuyForm && (pdpBuyForm.querySelector('[data-wolf-primary-cta]') || pdpBuyForm.querySelector('button[type=submit][name=add]'));
  var pdpCloser = pdpBuyForm && document.querySelector('.pdp-closer');
  var closerTick = false;
  var closerUpdate = function () {
    closerTick = false;
    if (!alive) return;
    if (!pdpCloser || !pdpPrimaryCta) return;
    var vw = window.innerWidth || document.documentElement.clientWidth;
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var r = pdpPrimaryCta.getBoundingClientRect();
    var onScreen = r.bottom > 0 && r.top < vh && r.width > 0;
    pdpCloser.classList.toggle('is-dup', vw >= 761 && onScreen);
  };
  if (pdpCloser && pdpPrimaryCta) {
    var closerQueue = function () {
      if (closerTick) return;
      closerTick = true;
      closerFrame = requestAnimationFrame(closerUpdate);
    };
    listen(window, 'scroll', closerQueue, { passive: true });
    listen(window, 'resize', closerQueue, { passive: true });
    listen(window, 'load', closerQueue);
    closerUpdate();
  }
  var stickyBar = document.querySelector('div.sticky-cta');
  if (stickyBar) {
    var stickyBtn = stickyBar.querySelector('.btn-primary') || stickyBar.querySelector('.btn');
    var isPdpBar = !!(stickyBtn && stickyBtn.tagName === 'BUTTON' && stickyBtn.getAttribute('form') === 'wolf-buy-form' && pdpBuyForm);
    var startEl = isPdpBar
      ? (pdpPrimaryCta || document.querySelector('.pdp-cta') || pdpBuyForm)
      : document.querySelector('#top');
    var endEl = null;
    var isHomeBar = stickyBar.hasAttribute('data-wolf-sticky-home');
    var untilSel = stickyBar.getAttribute('data-wolf-sticky-until');
    if (untilSel) { try { endEl = document.querySelector(untilSel); } catch (e) { endEl = null; } }
    if (!endEl && (isPdpBar || isHomeBar)) {
      /* footer / newsletter zone: whichever comes first in the document */
      endEl = isHomeBar ? document.querySelector('footer.site-foot') : document.querySelector('section.pack, .newsletter-section, footer.site-foot, footer');
    }
    if (!endEl && !isPdpBar && !isHomeBar && stickyBtn && stickyBtn.tagName === 'A') {
      var href = stickyBtn.getAttribute('href') || '';
      if (href.charAt(0) === '#' && href.length > 1) {
        endEl = document.getElementById(href.slice(1));
      } else {
        /* last top-level section that links to the bar's product; if a card row follows
           it directly, that row is the family's "choose your version" and belongs too
           (home: flagship + why + the vest row, not the belt row after). Heuristic — a
           page whose layout differs should set the section's "Stop after" setting. */
        var path = '';
        try { path = new URL(href, location.href).pathname.replace(/\/+$/, ''); } catch (e) {}
        var secs = document.querySelectorAll('.shopify-section');
        var isRow = function (sec) { return !!(sec && sec.querySelector && sec.querySelector('section.commerce')); };
        if (path) {
          for (var si = secs.length - 1; si >= 0; si--) {
            if (secs[si].contains(stickyBar)) continue;
            var links = secs[si].querySelectorAll('a[href]');
            for (var li = 0; li < links.length; li++) {
              var lp = '';
              try { lp = new URL(links[li].getAttribute('href'), location.href).pathname.replace(/\/+$/, ''); } catch (e) {}
              if (lp === path) { endEl = secs[si]; break; }
            }
            if (endEl) break;
          }
          if (endEl && !isRow(endEl) && isRow(endEl.nextElementSibling)) endEl = endEl.nextElementSibling;
        }
        if (!endEl) {
          var rows = document.querySelectorAll('section.commerce');
          if (rows.length) endEl = rows[rows.length - 1];
        }
      }
    }
    if (startEl || endEl) {
      stickyBar.classList.add('armed');
      var stickyTick = false;
      var stickyUpdate = function () {
        stickyTick = false;
        if (!alive) return;
        var vh = window.innerHeight || document.documentElement.clientHeight;
        var started = true, ended = false;
        if (startEl) started = startEl.getBoundingClientRect().bottom <= 0;
        /* ended once the boundary is on screen: on product pages that is the footer /
           newsletter zone (its TOP edge entering the viewport); elsewhere the boundary's
           bottom edge, so what follows it is already visible and the bar never sits over it */
        if (endEl) ended = (isPdpBar || isHomeBar) ? endEl.getBoundingClientRect().top <= vh : endEl.getBoundingClientRect().bottom <= vh;
        stickyBar.classList.toggle('show', started && !ended);
        if (started && !ended) document.documentElement.style.setProperty('--wolf-sticky-height', stickyBar.getBoundingClientRect().height + 'px');
      };
      var stickyQueue = function () {
        if (stickyTick) return;
        stickyTick = true;
        stickyFrame = requestAnimationFrame(stickyUpdate);
      };
      listen(window, 'scroll', stickyQueue, { passive: true });
      listen(window, 'resize', stickyQueue, { passive: true });
      listen(window, 'pageshow', stickyQueue);
      listen(window, 'load', stickyQueue);
      stickyUpdate();
    }

    /* PDP: the bar names the variant it will submit, mirrored from the buy box's checked
       control (label text of the checked input[name=id], or the selected <option>),
       updated on every change so bar and buy box never disagree */
    var stickyVar = stickyBar.querySelector('[data-wolf-sticky-variant]');
    var buyForm = isPdpBar && document.getElementById('wolf-buy-form');
    if (stickyVar && buyForm) {
      var stickyVariantText = function () {
        var el = buyForm.querySelector('input[name=id]:checked');
        var txt = '';
        if (el) {
          var lab = el.closest && el.closest('label');
          var nm = lab && (lab.querySelector('.o-n') || lab.querySelector('.cvp-opt-t'));
          txt = (nm || lab || {}).textContent || '';
          /* grouped chips show only option 2/3 per chip; the group heading carries
             option 1 (colour), so the bar reads "Black / XL" like the flat rows do */
          var grp = lab && lab.closest && lab.closest('.vg');
          var gh = grp && grp.querySelector('.vg-h');
          if (gh && txt) txt = gh.textContent.trim() + ' / ' + txt.trim();
        } else {
          var sel = buyForm.querySelector('select[name=id]');
          var opt = sel && sel.selectedOptions && sel.selectedOptions[0];
          if (opt) txt = (opt.textContent || '').split(' — ')[0];
        }
        return txt.replace(/\s+/g, ' ').replace(/\s*(—|·)\s*sold out\s*$/i, '').trim();
      };
      var stickyVariantSync = function () {
        var t = stickyVariantText();
        if (t) stickyVar.textContent = t;
      };
      stickyVariantSync();
      listen(buyForm, 'change', function (ev) {
        if (ev.target && ev.target.name === 'id') stickyVariantSync();
      });
      listen(window, 'pageshow', stickyVariantSync);
    }
  }

  };
  window.__wolfRefreshPdpSticky();

  /* ---- hero video: homepage opts into mobile autoplay; other mobile heroes stay manual ----
     Homepage autoplay starts once at load or DOMContentLoaded + 2500ms, never before
     DOMContentLoaded. Reduced motion and save-data require Play; policy rejection restores it.
     The visible toggle pauses/resumes. Offscreen/hidden pages pause, while a user
     pause survives visibility changes. The poster stays until a frame is ready. */
  var hv = document.querySelector('video.hero-video');
  if (hv && !hv.dataset.wolfVideoBound) {
    hv.dataset.wolfVideoBound = 'true';
    var hvToggle = document.querySelector('[data-hero-video-toggle]');
    var hvLabel = hvToggle && hvToggle.querySelector('[data-hero-video-label]');
    var hvPlayIcon = hvToggle && hvToggle.querySelector('[data-hero-video-play]');
    var hvPauseIcon = hvToggle && hvToggle.querySelector('[data-hero-video-pause]');
    var hvStatus = document.querySelector('[data-hero-video-status]');
    var vidMq = matchMedia('(max-width: 760px)');
    var vidRm = matchMedia('(prefers-reduced-motion: reduce)');
    var hvRequested = false, hvUserPaused = false, hvPending = false, hvFailed = false;
    var hvReady = false, hvLeaving = false, hvEpoch = 0, hvFrame = null, hvWait = null;
    var hvNavigation = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
    var hvDomReady = document.readyState === 'complete' || !!(hvNavigation && hvNavigation.domContentLoadedEventStart);
    var hvViewport = hv.closest('section') || hv;
    var hvRect = hvViewport.getBoundingClientRect();
    var hvVisible = hvRect.bottom > 0 && hvRect.top < innerHeight;
    var hvSource = function () {
      var src = hv.getAttribute(vidMq.matches ? 'data-src-mobile' : 'data-src-desktop') || '';
      return mediaUrlOk(src) ? src : '';
    };
    var hvManualOnly = function () {
      return (vidMq.matches && hv.dataset.mobileAutoplay !== 'true') || vidRm.matches || (navigator.connection && navigator.connection.saveData);
    };
    var hvWanted = function () { return !hvUserPaused && (hvRequested || !hvManualOnly()); };
    var hvActive = function () { return hvVisible && !document.hidden && !hvLeaving; };
    var syncVidControl = function () {
      if (!hvToggle) return;
      var playing = !hv.paused && !hvPending;
      var label = hvPending ? 'Loading…' : playing ? 'Pause video' : hvFailed ? 'Retry video' : 'Play video';
      hvToggle.hidden = !hvSource();
      hvToggle.setAttribute('aria-label', hvPending ? 'Loading video' : label);
      hvToggle.setAttribute('data-video-state', hvPending ? 'loading' : playing ? 'playing' : 'paused');
      if (hvLabel) hvLabel.textContent = label;
      if (hvPlayIcon) {
        if (playing || hvPending) hvPlayIcon.setAttribute('hidden', '');
        else hvPlayIcon.removeAttribute('hidden');
      }
      if (hvPauseIcon) {
        if (!playing && !hvPending) hvPauseIcon.setAttribute('hidden', '');
        else hvPauseIcon.removeAttribute('hidden');
      }
    };
    var cancelVidFrame = function () {
      if (hvFrame !== null) {
        if (hv.cancelVideoFrameCallback) hv.cancelVideoFrameCallback(hvFrame);
        else cancelAnimationFrame(hvFrame);
        hvFrame = null;
      }
      clearTimeout(hvWait);
      hvWait = null;
    };
    var pauseVid = function (unload) {
      hvEpoch++;
      hvPending = false;
      cancelVidFrame();
      hv.pause();
      if (unload) {
        hv.classList.remove('hv-on', 'hv-requested');
        if (hv.getAttribute('src')) { hv.removeAttribute('src'); hv.load(); }
      }
      syncVidControl();
    };
    var failVid = function (epoch) {
      if (epoch !== hvEpoch) return;
      hvFailed = hvRequested || !!hv.error;
      hvUserPaused = true;
      pauseVid(true);
      // Automatic failures change the visible control without announcing on page load.
      if (hvStatus && hvRequested) hvStatus.textContent = 'Video could not play. Select Retry video to try again.';
    };
    var startVid = function () {
      var src = hvSource();
      if (!hvDomReady || !src || !hvWanted() || !hvActive()) return;
      if (hvPending && hv.getAttribute('src') === src) return;
      if (hv.getAttribute('src') === src && !hv.paused) return;
      pauseVid(hv.getAttribute('src') !== src);
      var epoch = hvEpoch;
      hvFailed = false;
      hvPending = true;
      if (hvStatus) hvStatus.textContent = '';
      hv.classList.toggle('hv-requested', hvRequested);
      if (hv.getAttribute('src') !== src) { hv.src = src; hv.load(); }
      syncVidControl();
      hvWait = setTimeout(function () { failVid(epoch); }, 20000);
      try {
        var play = hv.play();
        if (play && play.catch) play.catch(function () { failVid(epoch); });
      } catch (err) { failVid(epoch); }
    };
    hv.addEventListener('playing', function () {
      if (!hvWanted() || !hvActive()) { pauseVid(false); return; }
      var epoch = hvEpoch;
      var reveal = function () {
        hvFrame = null;
        if (epoch !== hvEpoch || !hvWanted() || !hvActive() || hv.paused) return;
        if (hv.readyState < 2) return;
        clearTimeout(hvWait);
        hvWait = null;
        hvPending = false;
        hv.classList.add('hv-on');
        syncVidControl();
      };
      if (hv.requestVideoFrameCallback) hvFrame = hv.requestVideoFrameCallback(reveal);
      else hvFrame = requestAnimationFrame(function () {
        if (epoch !== hvEpoch) return;
        hvFrame = requestAnimationFrame(reveal);
      });
    });
    hv.addEventListener('pause', syncVidControl);
    hv.addEventListener('error', function () { if (hv.error && hv.getAttribute('src')) failVid(hvEpoch); });
    var syncVid = function () {
      if (!hvActive() || !hvWanted()) {
        pauseVid(hvManualOnly() && !hvRequested);
      } else if (hvReady || hvRequested) startVid();
      syncVidControl();
    };
    if (hvToggle) hvToggle.addEventListener('click', function () {
      if (hvPending) {
        // A Play tap racing the automatic attempt confirms playback, never cancels it.
        hvRequested = true;
        hvUserPaused = false;
        hv.classList.add('hv-requested');
      } else if (!hv.paused) {
        hvUserPaused = true;
        pauseVid(false);
      } else {
        hvRequested = true;
        hvUserPaused = false;
        hvFailed = false;
        startVid();
      }
    });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        hvVisible = entries[0].isIntersecting;
        syncVid();
      }, { threshold: 0 }).observe(hvViewport);
    } else {
      var hvScrollPending = false;
      var checkVidViewport = function () {
        if (hvScrollPending) return;
        hvScrollPending = true;
        requestAnimationFrame(function () {
          hvScrollPending = false;
          var rect = hvViewport.getBoundingClientRect();
          hvVisible = rect.bottom > 0 && rect.top < innerHeight;
          syncVid();
        });
      };
      addEventListener('scroll', checkVidViewport, { passive: true });
      addEventListener('resize', checkVidViewport);
    }
    document.addEventListener('visibilitychange', syncVid);
    addEventListener('pagehide', function () { hvLeaving = true; pauseVid(false); });
    addEventListener('pageshow', function (e) { if (e.persisted) { hvLeaving = false; syncVid(); } });
    var onVidPreference = function () {
      // A newly requested reduced-motion preference stops existing motion immediately.
      if (vidRm.matches) { hvRequested = false; hvUserPaused = true; }
      syncVid();
    };
    if (vidMq.addEventListener) {
      vidMq.addEventListener('change', syncVid);
      vidRm.addEventListener('change', onVidPreference);
    } else {
      vidMq.addListener(syncVid);
      vidRm.addListener(onVidPreference);
    }
    if (navigator.connection && navigator.connection.addEventListener) {
      navigator.connection.addEventListener('change', syncVid);
    }
    var hvArmTimer = null;
    var armVid = function () {
      if (hvReady) return;
      hvReady = true;
      clearTimeout(hvArmTimer);
      removeEventListener('load', armVid);
      syncVid();
    };
    var onVidDomReady = function () {
      hvDomReady = true;
      if (hv.dataset.mobileAutoplay === 'true' && !hvReady) {
        hvArmTimer = setTimeout(armVid, 2500);
      }
      if (hvRequested) syncVid();
    };
    syncVidControl();
    if (hvDomReady) onVidDomReady();
    else document.addEventListener('DOMContentLoaded', onVidDomReady, { once: true });
    if (hv.dataset.mobileAutoplay === 'true') {
      if (document.readyState === 'complete') armVid();
      else addEventListener('load', armVid, { once: true });
    } else {
      // Non-opted-in collection heroes retain their existing desktop load/idle policy.
      var armLegacyVid = function () {
        if ('requestIdleCallback' in window) requestIdleCallback(armVid, { timeout: 3000 });
        else setTimeout(armVid, 800);
      };
      if (document.readyState === 'complete') armLegacyVid();
      else addEventListener('load', armLegacyVid, { once: true });
    }
  }

})();

/* ---------- generic PDP: variant choice drives the photo + price (2026-08-03) ----------
   Progressive enhancement over the pure-HTML picker: each variant control carries its
   variant's photo (data-img) and formatted price (data-price) from Liquid. Without JS
   the picker still adds the chosen variant to cart — the gallery just stays put.
   Submission integrity, layered: (1) the sanitizer at the top of this file already
   stripped form controls and behavior hooks out of rendered-description HTML; (2) any
   [name=id] control that is not a DOM DESCENDANT of the buy form or not one of our own
   is removed on load and at submit; (3) a formdata listener rebuilds the id entry from
   the checked control during entry-list construction — this one also covers controls
   injected after our submit listener and form.submit() FormData consumers. */
(function () {
  var pdpVariantBindings = new WeakMap();
  function bindForm(form) {
    if (pdpVariantBindings.has(form)) return;
    var cleanups = [];
    function listen(target, type, handler, options) {
      target.addEventListener(type, handler, options);
      cleanups.push(function () { target.removeEventListener(type, handler, options); });
    }
    pdpVariantBindings.set(form, function () {
      cleanups.forEach(function (cleanup) { cleanup(); });
      pdpVariantBindings.delete(form);
    });
  try {
    var scope = form.closest('.pdp') || form.closest('.shopify-section') || document;
    var gal = scope.querySelector('.pdp-gallery');
    var main = gal && gal.querySelector('.g-main');
    var mainImg = main && main.querySelector('img');
    // image_url emits protocol-relative URLs while el.src reads back absolute — compare normalized
    var norm = function (u) { try { return new URL(u, location.href).href; } catch (e) { return u; } };
    // local copy of the media-URL guard (the main IIFE's is closure-scoped)
    var urlOk = function (u) {
      if (!u || /[\s\\\u0000-\u001F\u007F]/.test(u)) return false;
      if (/^\/[^/\\]/.test(u)) return true;
      try { var p = new URL(u, document.baseURI); return p.protocol === 'https:' && (p.host === location.host || p.host === 'cdn.shopify.com'); } catch (e) { return false; }
    };

    /* Server-truth variant allowlist: Liquid emits data-vids on the form (theme only;
       empty on the prototype, where validation degrades to the structural checks).
       Class names and DOM position are attacker-writable — a value outside this set
       is refused no matter where its control sits. */
    var allowedIds = {};
    var hasAllowlist = false;
    (form.getAttribute('data-vids') || '').split(',').forEach(function (v) {
      v = v.trim(); if (v) { allowedIds[v] = true; hasAllowlist = true; }
    });
    var idAllowed = function (v) { return !hasAllowlist || allowedIds[String(v)] === true; };
    /* the genuine picker is in the server-rendered initial HTML, so the FIRST matching
       element in tree order is Liquid's — content-smuggled copies render later (the
       description sits after {% endform %}) */
    var pickerRoot = form.querySelector('.pdp-vrows, select.pdp-select');
    /* ours() gates on CONTAINMENT first: our controls are descendants of the form;
       smuggled form=-attribute controls never are. Within the form, only controls
       inside the ONE captured picker (not any element wearing its class) count. */
    var ours = function (el) {
      if (!form.contains(el)) return false;
      if (!idAllowed(el.value)) return false;
      if (pickerRoot) return pickerRoot.contains(el);
      /* the direct-child hidden id exists ONLY on single-variant products — on a page
         with a picker, any hidden id is an app's override attempt */
      return el.type === 'hidden' && el.parentElement === form;
    };
    var pickedControl = function () {
      if (pickerRoot) {
        return pickerRoot.tagName === 'SELECT'
          ? pickerRoot.selectedOptions[0]
          : pickerRoot.querySelector('input[name=id]:checked');
      }
      return form.querySelector(':scope > input[type=hidden][name=id]');
    };
    /* Cart params an authored/injected control must never set. `id` has the allowlist
       above; these have no legitimate control in this buy box at all, so ANY bearer is
       foreign (pass-4: quantity=99 / selling_plan / return_to were unguarded while id
       was locked down). Liquid's own {% form %} hidden fields are exempt by name. */
    var FOREIGN_NAMES = /^(quantity|selling_plan|return_to|checkout|properties\[|items\[|discount)/i;
    var lastPickedId = null;
    var sweep = function () {
      Array.prototype.slice.call(form.elements).forEach(function (el) {
        var foreign = el.name === 'id' ? !ours(el) : FOREIGN_NAMES.test(el.name || '');
        if (foreign && el.parentNode) {
          el.parentNode.removeChild(el);
        }
      });
      /* a removed foreign checked radio leaves the group with NO checked control —
         the form would post without an id. Restore the default. */
      var radios = pickerRoot ? pickerRoot.querySelectorAll('input[name=id]') : [];
      if (radios.length && !pickerRoot.querySelector('input[name=id]:checked')) {
        /* restore the shopper's OWN last pick, not "the first available" — silently
           substituting a different variant is the failure mode the formdata path
           deliberately avoids by failing closed (pass-5 consistency finding) */
        var restored = false;
        if (lastPickedId) {
          for (var j = 0; j < radios.length; j++) {
            if (radios[j].value === lastPickedId && !radios[j].disabled) { radios[j].checked = true; restored = true; break; }
          }
        }
        if (!restored) {
          for (var i = 0; i < radios.length; i++) { if (!radios[i].disabled) { radios[i].checked = true; break; } }
        }
      }
    };
    sweep();
    listen(form, 'submit', sweep);
    /* formdata fires during entry-list construction — after every submit listener,
       and for FormData(form) consumers too. The id entry is rebuilt from the control
       the shopper actually picked. */
    listen(form, 'formdata', function (e) {
      try {
        /* ALWAYS rebuild — an early return here leaks whatever the native entry list
           collected. An injected checked radio in a fake picker unchecks the shopper's
           real pick, making pickedControl() null; bailing at that point posted the
           attacker's entries verbatim (caught by verify-pdp probe 13). */
        e.formData.delete('id');
        /* the entry list is built from the DOM at submit time — a control injected
           after our sweep (or one the sweep could not reach) still contributes. Drop
           every foreign cart param unconditionally; none has a legit control here. */
        ['quantity', 'selling_plan', 'return_to', 'checkout', 'discount'].forEach(function (k) { e.formData.delete(k); });
        Array.prototype.slice.call(e.formData.keys ? e.formData.keys() : []).forEach(function (k) {
          if (/^(properties\[|items\[)/i.test(k)) e.formData.delete(k);
        });
        var el = pickedControl();
        var v = el && !el.disabled && (el.tagName === 'OPTION' || el.type === 'radio' || el.type === 'hidden') ? el.value : null;
        /* fail CLOSED on no pick or an id outside the server-truth set: a cart add
           with no id errors visibly; appending an attacker's id would succeed silently */
        if (v && idAllowed(v)) e.formData.append('id', v);
      } catch (err) {}
    });

    // :has()-free fallback for the selected-row outline (older Safari/Firefox)
    var markChecked = function () {
      Array.prototype.forEach.call(form.querySelectorAll('.pdp-vrows label.opt-row'), function (l) {
        var r = l.querySelector('input[type=radio]');
        l.classList.toggle('is-checked', !!(r && r.checked));
      });
    };
    /* Keep the CTA label with the variant owner so section reloads bind it too.
       Re-query it because the sold-out toggle replaces the button's innerHTML. */
    function syncCtaVariant() {
      var size = form.querySelector('input[name="id"]:checked');
      var stock = form.querySelector('[data-wolf-stock-line]');
      if (stock) stock.hidden = !size || size.disabled;
      var out = form.querySelector('[data-wolf-cta-variant]');
      if (!out) return;
      var col = form.querySelector('[data-wolf-colour-names] .is-on, [data-pk-color-name] .is-on');
      var parts = [];
      if (col) parts.push(col.textContent.trim());
      else {
        var cin = form.querySelector('input[name="wolf_color"]:checked');
        if (cin) parts.push(cin.value);
      }
      if (size && size.hasAttribute('data-variant-title')) parts = [size.getAttribute('data-variant-title')];
      else if (size && size.hasAttribute('data-size')) parts.push(size.getAttribute('data-size').replace('(', '· ').replace(')', ' in'));
      out.textContent = parts.join(' · ');
    }
    /* the sticky bar's price span only carries .pdp-price-num on product templates
       (Liquid-gated), so this page-global update can never repaint a bar pinned to a
       DIFFERENT product on a landing page */
    var applyControl = function (el) {
      if (!el) return;
      markChecked();
      var price = el.getAttribute('data-price');
      if (price) {
        Array.prototype.forEach.call(document.querySelectorAll('.pdp-price-num'), function (pe) { pe.textContent = price; });
        /* "from $X" would lie once a concrete variant is picked */
        Array.prototype.forEach.call(document.querySelectorAll('.pdp-price-prefix'), function (pp) { pp.textContent = ''; });
      }
      var src = el.getAttribute('data-img');
      if (!src || !mainImg || !urlOk(src) || norm(mainImg.src) === norm(src)) return;
      /* srcset outranks src — drop it or the browser keeps the old variant's photo */
      mainImg.removeAttribute('srcset'); mainImg.removeAttribute('sizes');
      mainImg.src = src;
      if (el.hasAttribute('data-img-alt')) mainImg.alt = el.getAttribute('data-img-alt');
      /* stale zoom state on the previous photo must not carry over */
      if (main) { main.classList.remove('zoomed'); main.setAttribute('aria-pressed', 'false'); mainImg.style.transformOrigin = '50% 50%'; }
      var nsrc = norm(src);
      if (gal) Array.prototype.forEach.call(gal.querySelectorAll('.g-thumbs button'), function (b) {
        if (norm(b.getAttribute('data-full') || '') === nsrc) b.setAttribute('aria-current', 'true');
        else b.removeAttribute('aria-current');
      });
    };
    markChecked();
    listen(form, 'change', function (ev) {
      var t = ev.target;
      if (!t || t.name !== 'id' || !ours(t)) return;
      lastPickedId = t.tagName === 'SELECT' ? (t.selectedOptions[0] || {}).value : t.value;
      applyControl(t.tagName === 'SELECT' ? t.selectedOptions[0] : t);
      syncCtaVariant();
    });

    /* ---- two-step picker (spoke picker-v2, 2026-09-02): .pdp-picker in wolf-pdp-buy ----
       Colour radios (.pk-cin, data-color, NOT name=id in the two-step case: their form=
       names no element, so they never post) reveal the matching size group (.vg[data-color])
       and print the colour name. site.css does the same with :has(); this mirror covers
       browsers without :has() and the cases CSS cannot: picking the same size in the new
       colour (else the first in-stock one), firing the price/photo sync, syncing the colour
       step to a ?variant= deep link or restored form state, and an all-sold-out colour
       (struck but selectable): no size stays checked, so the formdata guard above posts
       no id and the in-form button is disabled with a plain status line. */
    var picker = pickerRoot && pickerRoot.classList && pickerRoot.classList.contains('pdp-picker') ? pickerRoot : null;
    var pkTwo = !!(picker && picker.classList.contains('pdp-picker--two'));
    var pkColorNames = picker ? picker.querySelectorAll('.pk-names > span') : [];
    var pkStatus = picker && picker.querySelector('[data-pk-status]');
    var pkSubmit = picker && form.querySelector('button[type=submit][name=add]');
    var pkSubmitLabel = pkSubmit ? pkSubmit.innerHTML : '';
    var pkNameFor = function (radio) {
      var lab = radio && radio.id ? picker.querySelector('label[for="' + radio.id + '"] .sr') : null;
      return lab ? lab.textContent.replace(/\s*sold out\s*$/, '').trim() : (radio && radio.value) || '';
    };
    var pkColorOf = function (radio) {
      var g = radio && radio.closest && radio.closest('.vg');
      if (g && g.getAttribute('data-color')) return g.getAttribute('data-color');
      return radio && radio.getAttribute ? radio.getAttribute('data-color') : null;
    };
    var pkShowColor = function (ck, name) {
      if (!picker) return;
      picker.classList.add('pk-js');
      Array.prototype.forEach.call(picker.querySelectorAll('.pk-sizes .vg'), function (g) {
        g.classList.toggle('is-on', g.getAttribute('data-color') === ck);
      });
      Array.prototype.forEach.call(pkColorNames, function (sp) {
        sp.classList.toggle('is-on', sp.textContent === name);
      });
      var cin = picker.querySelector('.pk-cin[data-color="' + ck.replace(/["\\]/g, '') + '"]');
      if (cin && !cin.checked) cin.checked = true;
    };
    var pkSetSoldOut = function (colourName) {
      if (!pkTwo) return;
      var out = !!colourName;
      if (pkStatus) {
        pkStatus.textContent = out ? 'Sold out in ' + colourName + '. Pick another color.' : '';
        pkStatus.hidden = !out;
      }
      if (pkSubmit) {
        pkSubmit.disabled = out;
        pkSubmit.innerHTML = out ? 'Sold out in ' + colourName.replace(/[<>&]/g, '') : pkSubmitLabel;
      }
      syncCtaVariant();
    };
    if (picker) {
      picker.classList.add('pk-js');
      /* colour step -> size group (same size if in stock, else first in stock, else none) */
      listen(picker, 'change', function (ev) {
        var t = ev.target;
        if (!t || !t.classList || !t.classList.contains('pk-cin')) return;
        var ck = t.getAttribute('data-color') || '';
        if (t.name === 'id') {
          /* single-option colour swatches: the radio IS the variant; only the name needs us */
          pkShowColor(ck, pkNameFor(t));
          return;
        }
        var group = picker.querySelector('.pk-sizes .vg[data-color="' + ck.replace(/["\\]/g, '') + '"]');
        pkShowColor(ck, t.value);
        if (!group) return;
        var prev = pickerRoot.querySelector('input[name=id]:checked');
        var want = prev ? prev.getAttribute('data-size') : null;
        var radios = group.querySelectorAll('input[name=id]');
        var next = null, first = null, i;
        for (i = 0; i < radios.length; i++) {
          if (radios[i].disabled) continue;
          if (!first) first = radios[i];
          if (want && radios[i].getAttribute('data-size') === want) { next = radios[i]; break; }
        }
        next = next || first;
        if (next) {
          if (!next.checked) { next.checked = true; }
          lastPickedId = next.value;
          pkSetSoldOut(null);
          applyControl(next);
          /* programmatic .checked fires no event: the sticky bar's variant line listens
             for a bubbling change on name=id (verify-r3 R-1) */
          try { next.dispatchEvent(new Event('change', { bubbles: true })); } catch (e) {}
        } else {
          /* every size in this colour is sold out: no id may stay checked (a hidden radio
             from the previous colour would post the WRONG colour) */
          if (prev) prev.checked = false;
          lastPickedId = null;
          pkSetSoldOut(t.value);
          /* still show this colour's photo: any of its radios carries it */
          if (radios.length) applyControl(radios[0]);
          markChecked();
        }
      });
    }
    /* browser form restoration (back/bfcache, Firefox soft reload) re-checks a control
       AFTER scripts run without firing change — resync so display and submission agree */
    var resync = function () {
      var el = pickedControl();
      applyControl(el);
      if (!picker || !el) { syncCtaVariant(); return; }
      /* colour step follows the checked size (deep link / restored state) */
      var ck = pkColorOf(el);
      var g = el.closest && el.closest('.vg');
      var gh = g && g.querySelector('.vg-h');
      var name = gh ? gh.textContent.trim() : pkNameFor(el);
      if (ck) pkShowColor(ck, name);
      pkSetSoldOut(null);
      syncCtaVariant();
    };
    resync();
    listen(window, 'pageshow', resync);
  } catch (e) { /* fail open: the pure-HTML picker still posts the picked variant */ }
  }
  window.__wolfBindPdpVariants = function (root) {
    root.querySelectorAll('#wolf-buy-form').forEach(bindForm);
  };
  window.__wolfUnbindPdpVariants = function (root) {
    root.querySelectorAll('#wolf-buy-form').forEach(function (form) {
      var cleanup = pdpVariantBindings.get(form);
      if (cleanup) cleanup();
    });
  };
  window.__wolfBindPdpVariants(document);
})();

/* :has()-free spacer for the fixed mobile buy bar — only when the bar has an actual CTA */
if (document.querySelector('div.sticky-cta .btn-primary, div.sticky-cta .btn')) document.documentElement.classList.add('has-sticky-cta');

/* ---------- generic PDP: bracket headers in imported copy become section leads ----------
   The catalog writes section headers as ASCII [HEADER] and fullwidth 【HEADER】 (dominant,
   40 products), with markup INSIDE or AROUND the brackets on many (<strong>-split brackets,
   <span>/<meta> fragments between bracket and text). Matching runs over the description's
   JOINED text-node content and wraps by character offset via Range — cross-node capable,
   and text-only, so bracket characters inside attribute values (data-pm-slice, hiccup
   blobs) can never match. Guards: a header must START a text node (mid-node brackets are
   prose — "Tested to [MIL-STD-810G]" stays put); a match must never cross a top-level
   block boundary (an unbalanced "[" in one <p> must not eat the elements between it and a
   "]" in a later <p>); headers containing links are left alone. The regex + caps predicate
   are MIRRORED in tools/sweep-pdp.mjs — change both or the sweep tests the wrong class.
   No-JS fallback: the copy keeps its brackets. */
(function () {
  // authored copy packs render the card grid server-side — only raw imports transform
  var desc = document.querySelector('.pdp-desc[data-import]');
  if (!desc) return;
  try {
    var rx = /[\[【]([^\[\]【】]{3,90}?)[\]】]/g;
    /* header = shouty caps; anything with lowercase is prose that happens to use brackets */
    var capsOk = function (h) { return !/[a-z]/.test(h) && (h.match(/[A-Z]/g) || []).length >= 3; };
    var INLINE = { STRONG: 1, B: 1, EM: 1, I: 1, SPAN: 1, U: 1 };
    var blockOf = function (node) {
      var el = node.nodeType === 1 ? node : node.parentElement;
      while (el && el.parentElement && el.parentElement !== desc) el = el.parentElement;
      return el && el.parentElement === desc ? el : desc;
    };

    var tw = document.createTreeWalker(desc, NodeFilter.SHOW_TEXT);
    var nodes = [], text = '';
    while (tw.nextNode()) { nodes.push({ n: tw.currentNode, start: text.length }); text += tw.currentNode.nodeValue; }
    if (text.length >= 8) {
      var matches = [], m;
      rx.lastIndex = 0;
      while ((m = rx.exec(text))) {
        if (!capsOk(m[1])) continue;
        matches.push({ start: m.index, end: m.index + m[0].length, head: m[1].replace(/\s+/g, ' ').trim() });
      }
      var locate = function (pos) {
        for (var i = nodes.length - 1; i >= 0; i--) {
          if (nodes[i].start <= pos) return { node: nodes[i].n, offset: pos - nodes[i].start };
        }
      };
      /* wrap back-to-front so earlier offsets stay valid (boundary text nodes keep their
         identity through deleteContents) */
      matches.reverse().forEach(function (mt) {
        try {
          var a = locate(mt.start);
          if (!a) return;
          if (a.node.nodeValue.slice(0, a.offset).trim() !== '') return;
          if (a.node.parentElement && a.node.parentElement.closest('a')) return;
          /* a header owns its line: preceding siblings up to a <br>/block start must be
             whitespace — "fits <strong>MOLLE</strong> [PALS] webbing" is prose even
             though "[PALS]…" happens to start its own text node */
          var boundaryOk = true;
          /* walk siblings, then climb through INLINE ancestors and keep walking: a
             bracket wrapped mid-sentence ("Fits <b>[MOLLE]</b> webbing") is the FIRST
             child of its <b>, so a siblings-only walk sees nothing before it and would
             wrongly promote it to a heading (pass-4 finding) */
          var cur = a.node;
          walk: while (cur && cur !== desc) {
            var prevN = cur.previousSibling;
            while (prevN) {
              if (prevN.nodeName === 'BR') break walk;
              var pt = prevN.nodeType === 3 ? prevN.nodeValue : prevN.textContent;
              if (pt && pt.trim() !== '') { boundaryOk = false; break walk; }
              prevN = prevN.previousSibling;
            }
            var par = cur.parentElement;
            /* stop at the block that owns the line; inline wrappers keep climbing */
            if (!par || par === desc || !INLINE[par.nodeName]) break;
            cur = par;
          }
          if (!boundaryOk) return;
          var b = locate(mt.end);
          if (!b) return;
          var aBlock = blockOf(a.node);
          if (blockOf(b.node) !== aBlock) return;
          /* fold ONE decorative glyph after the header ("】 ★ Constructed…") — but only
             within the SAME text node, so the fold can never cross a <br> or element
             boundary and eat a bullet list's first marker or its line break */
          var rest = b.node.nodeValue.slice(b.offset);
          var glyph = rest.match(/^\s*[★✦✔✅●•▪]\s*/);
          /* a second glyph downstream means these are bullet markers, not decoration —
             the first marker must survive */
          if (glyph && /[★✦✔✅●•▪]/.test(rest.slice(glyph[0].length, glyph[0].length + 200))) glyph = null;
          var bOffset = b.offset + (glyph ? glyph[0].length : 0);
          var range = document.createRange();
          range.setStart(a.node, a.offset);
          range.setEnd(b.node, Math.min(bOffset, b.node.nodeValue.length));
          if (range.cloneContents().querySelector('a')) return;
          range.deleteContents();
          var s = document.createElement('span');
          s.className = 'd-lead';
          s.setAttribute('role', 'heading');
          /* level 2: the leads sit directly under the PDP h1 with no h2 between */
          s.setAttribute('aria-level', '2');
          s.textContent = mt.head;
          range.insertNode(s);
          /* hoist out of emptied inline wrappers (<strong>【HEAD】</strong> shapes) so the
             lead sits at block level where the splitter can group it. The emptied wrapper
             stays in place — removing it could destroy attributes other tooling watches. */
          var par = s.parentElement;
          while (par && par !== desc && INLINE[par.tagName] && par.textContent.trim() === mt.head) {
            par.parentNode.insertBefore(s, par);
            par = s.parentElement;
          }
        } catch (e) { /* one weird paragraph must not take out the whole transform */ }
      });
    }

    /* ---- restructure: benefit sections become a scannable card grid ----
       splitBlock groups runs of text/inline nodes at each lead into per-section
       <div class="d-sec"> wrappers (a section may legally contain a <ul>, which a <p>
       cannot). In host mode (block === desc) existing element BLOCKS are left in place
       as their own boundaries — only loose text/inline runs get wrapped. */
    var BLOCKY = { P: 1, DIV: 1, UL: 1, OL: 1, TABLE: 1, H1: 1, H2: 1, H3: 1, H4: 1, H5: 1, H6: 1, BLOCKQUOTE: 1, FIGURE: 1, SECTION: 1 };
    var splitBlock = function (block, isHost) {
      var groups = [], cur = null;
      var flush = function () { cur = null; };
      Array.prototype.slice.call(block.childNodes).forEach(function (n) {
        if (isHost && n.nodeType === 1 && BLOCKY[n.nodeName]) { flush(); return; }
        if (n.nodeType === 1 && n.classList && n.classList.contains('d-lead')) { cur = [n]; groups.push(cur); return; }
        if (cur) cur.push(n); else { cur = [n]; groups.push(cur); }
      });
      var drop = function (n) { if (n && n.parentNode) n.parentNode.removeChild(n); return n; };
      groups.forEach(function (g) {
        while (g.length && (g[0].nodeName === 'BR' || (g[0].nodeType === 3 && !g[0].nodeValue.trim()))) drop(g.shift());
        while (g.length && (g[g.length - 1].nodeName === 'BR' || (g[g.length - 1].nodeType === 3 && !g[g.length - 1].nodeValue.trim()))) drop(g.pop());
        if (!g.length) return;
        var w = document.createElement('div');
        w.className = 'd-sec';
        /* host mode: wrapper takes the group's own position among desc children.
           non-host: the wrapper replaces part of the BLOCK, so it must land beside
           the block at its parent's level — inserting at g[0] would nest it INSIDE
           the block and read as one crammed multi-lead child. */
        if (isHost) { g[0].parentNode.insertBefore(w, g[0]); }
        else { block.parentNode.insertBefore(w, block); }
        g.forEach(function (n) { w.appendChild(n); });
      });
      if (!isHost && !block.childNodes.length) block.parentNode.removeChild(block);
    };

    /* some imports wrap the whole description in ONE <div> whose sub-blocks hold the
       leads (loop/hook-liner belts). Unwrap that shape — but never a wrapper that
       carries meaning (hidden/aria-hidden/style/dir/lang), where flattening would
       reveal hidden duplicates or drop styling. */
    Array.prototype.slice.call(desc.children).forEach(function (wrap) {
      if (wrap.tagName !== 'DIV') return;
      if (wrap.hidden || wrap.getAttribute('aria-hidden') === 'true' || wrap.getAttribute('style') || wrap.getAttribute('dir') || wrap.getAttribute('lang')) return;
      var wleads = wrap.querySelectorAll('.d-lead');
      if (wleads.length < 2) return;
      var wdirect = Array.prototype.filter.call(wleads, function (l) { return l.parentNode === wrap; });
      if (wdirect.length === wleads.length) return;
      while (wrap.firstChild) desc.insertBefore(wrap.firstChild, wrap);
      desc.removeChild(wrap);
    });

    if (desc.querySelector(':scope > .d-lead')) splitBlock(desc, true);
    Array.prototype.slice.call(desc.children).forEach(function (block) {
      if (block.classList.contains('d-lead')) return;
      var leads = block.querySelectorAll('.d-lead');
      if (leads.length < 2) return;
      var direct = Array.prototype.filter.call(leads, function (l) { return l.parentNode === block; });
      /* leads nested below the block's direct children: splitting risks tearing markup
         we don't understand — leave that block as prose */
      if (direct.length !== leads.length) return;
      splitBlock(block, false);
    });

    /* the grid flips on only when the split actually produced full section cards:
       ≥2 blocks holding exactly one lead each WITH body copy after it. A bailed
       multi-lead block, or a header-only block whose content sits in a sibling
       element, would render crammed or orphaned cards. */
    var sec = 0, crowded = false;
    Array.prototype.slice.call(desc.children).forEach(function (c) {
      var leads = c.querySelectorAll('.d-lead');
      var n = leads.length + (c.classList.contains('d-lead') ? 1 : 0);
      if (n >= 2) { crowded = true; return; }
      if (n === 1) {
        var leadText = c.classList.contains('d-lead') ? c.textContent.trim() : leads[0].textContent.trim();
        if (c.textContent.trim() === leadText) { crowded = true; return; }
        sec += 1;
      }
    });
    if (sec >= 2 && !crowded) desc.classList.add('sectioned');
  } catch (e) { /* fail open: prose with brackets beats a torn page */ }
  /* deterministic completion signal for tools/sweep-pdp.mjs — set even on failure */
  desc.setAttribute('data-wolf-desc', 'done');
})();

/* ============ theme-owned add to cart ============
   A third-party app extension binds a document-level BUBBLE click handler that
   preventDefault()s clicks inside form[action*="/cart/add"] and then fails to
   complete its own add on generic product templates (its selectors expect the
   old live theme's markup) — Add to Cart was a dead button on most of the
   catalog (audit 2026-08-06). This block takes deterministic ownership of the
   standard add flow at document CAPTURE (capture always precedes bubble at
   non-target nodes, regardless of registration order). Design adversarially
   reviewed by Sol: form-level lock (not per-button), 4xx = explicit rejection
   (unlock + message), transport/5xx failure = indeterminate (stay locked, tell
   the shopper to check the cart — a retry could double-add), native fallback
   only BEFORE any fetch was attempted, locale-aware routes, submitter
   name/value preserved. After a confirmed add, refresh and validate the loaded
   SmartCart before opening it; the native cart remains the bounded fallback. */
(function () {
  var lockedForms = new WeakSet();

  function rootUrl() {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    var u = new URL(root || '/', window.location.origin);
    /* routes.root is platform-emitted, but never trust it off-origin: a poisoned value
       would siphon the form POST and turn the post-add redirect into a phishing hop */
    if (u.origin !== window.location.origin) u = new URL('/', window.location.origin);
    return u;
  }
  function cartAddUrl() { return new URL('cart/add.js', rootUrl()).href; }
  function cartUrl() { return new URL('cart', rootUrl()).href; }

  /* Refresh presentation only: the confirmed POST above remains the sole cart writer.
     Rebuy can return its previous cart for a discarded response, or omit the callback
     on an error. Neither outcome may open an empty/stale drawer or repeat the add. */
  var cartPresentationInFlight = false;
  var cartOpenGuards = new WeakMap();
  function suppressCartAutoOpen(sc) {
    var guard = cartOpenGuards.get(sc);
    if (!guard) {
      guard = { count: 0, previous: sc.skip_open };
      cartOpenGuards.set(sc, guard);
    }
    guard.count++;
    sc.skip_open = true;
    var released = false;
    return function () {
      if (released) return;
      released = true;
      if (--guard.count === 0) {
        sc.skip_open = guard.previous;
        cartOpenGuards.delete(sc);
      }
    };
  }
  window.wolfOpenConfirmedCart = function (payload, onOpen, onFallback) {
    var rebuy = window.Rebuy;
    var sc = rebuy && rebuy.SmartCart;
    var rows = payload && (Array.isArray(payload.items) ? payload.items : [payload]);
    var expected = {};
    if (rows) rows.forEach(function (item) {
      var id = Number(item.variant_id || item.id), qty = Number(item.quantity);
      if (id > 0 && qty > 0) expected[id] = (expected[id] || 0) + qty;
    });
    if (cartPresentationInFlight || !Object.keys(expected).length || !rebuy || rebuy._status !== 'initialized' || !rebuy.Cart || typeof rebuy.Cart.fetchShopifyCart !== 'function' || !sc || sc.status !== 'ready' || typeof sc.show !== 'function' || (sc.skip_open && (!cartOpenGuards.has(sc) || cartOpenGuards.get(sc).previous))) {
      onFallback(); return;
    }
    function containsAddedItems(cart) {
      if (!cart || !Array.isArray(cart.items)) return false;
      return Object.keys(expected).every(function (id) {
        return cart.items.reduce(function (count, item) {
          return count + (Number(item.variant_id || item.id) === Number(id) ? Number(item.quantity) || 0 : 0);
        }, 0) >= expected[id];
      });
    }
    function containsRenderedItems(drawer) {
      if (!drawer) return false;
      var rendered = Array.prototype.slice.call(drawer.querySelectorAll('.rebuy-cart__flyout-item'));
      return Object.keys(expected).every(function (id) {
        var item = sc.cart.items.find(function (entry) { return Number(entry.variant_id || entry.id) === Number(id); });
        if (!item || !item.handle) return false;
        return rendered.some(function (row) {
          if (!row.classList.contains('product-' + item.handle) || !row.getClientRects().length) return false;
          var title = row.querySelector('.rebuy-cart__flyout-item-product-title');
          var variant = row.querySelector('.rebuy-cart__flyout-item-variant-title');
          if (!title || !title.textContent.trim() || (item.variant_title && (!variant || variant.textContent.trim() !== item.variant_title.trim()))) return false;
          var quantity = row.querySelector('.rebuy-cart__flyout-item-quantity-widget-label');
          if (!quantity) return true; // Rebuy intentionally hides quantity controls for some items.
          var value = Array.prototype.filter.call(quantity.childNodes, function (node) { return node.nodeType === 3; }).map(function (node) { return node.textContent; }).join('').trim();
          return Number(value) >= expected[id];
        });
      });
    }
    var releaseAutoOpen = suppressCartAutoOpen(sc), settled = false, refreshHandled = false, timer;
    cartPresentationInFlight = true;
    function finish(opened) {
      if (settled) return;
      settled = true;
      clearTimeout(timer);
      releaseAutoOpen();
      cartPresentationInFlight = false;
      if (opened) onOpen(); else onFallback();
    }
    timer = setTimeout(function () { finish(false); }, 2500);
    try {
      rebuy.Cart.fetchShopifyCart(function (cart) {
        if (settled || refreshHandled) return;
        refreshHandled = true;
        if (window.Rebuy !== rebuy || !containsAddedItems(cart) || !containsAddedItems(sc.cart)) { finish(false); return; }
        /* Existing rebuy:cart.change synchronizes the SmartCart model before this
           callback. Let Vue paint it before exposing the drawer. */
        setTimeout(function () {
          if (settled) return;
          try {
            if (sc.status !== 'ready' || !containsAddedItems(sc.cart) || !containsRenderedItems(document.querySelector('#rebuy-cart'))) { finish(false); return; }
            sc.show();
            setTimeout(function () {
              if (settled) return;
              var drawer = document.querySelector('#rebuy-cart');
              if (!drawer || drawer.getAttribute('aria-hidden') !== 'false' || !containsRenderedItems(drawer)) { finish(false); return; }
              finish(true);
            }, 32);
          } catch (error) { finish(false); }
        }, 32);
      });
    } catch (error) { finish(false); }
  };

  /* Smart Cart's widget can complete its own add while a later app's fetch
     wrapper bypasses Rebuy's cart observer. Recover the missed notification
     from the widget's confirmed-success event, never by repeating the POST. */
  var widgetAddSnapshots = new WeakMap();
  var pendingWidgetItems = {};
  var activeWidgetItems = {};
  var widgetRefreshTimer = null;
  var widgetRefreshRunning = false;
  var widgetCartLeaving = false;
  var widgetNavigationRelease = null;
  function updateHeaderCartCount(event) {
    var cart = event.detail && event.detail.cart && event.detail.cart.cart;
    if (!cart || !Number.isSafeInteger(cart.item_count) || cart.item_count < 0) return;
    document.querySelectorAll('header.nav a.cart b').forEach(function (count) {
      count.textContent = '(' + cart.item_count + ')';
    });
  }
  document.addEventListener('rebuy:cart.ready', updateHeaderCartCount);
  document.addEventListener('rebuy:cart.change', updateHeaderCartCount);
  window.addEventListener('pageshow', function (event) {
    if (!event.persisted || !widgetNavigationRelease) return;
    widgetNavigationRelease();
    widgetNavigationRelease = null;
    widgetCartLeaving = false;
    pendingWidgetItems = {};
    activeWidgetItems = {};
    widgetAddSnapshots = new WeakMap();
  });
  function smartCartWidget(detail) {
    return detail && detail.widget && Number(detail.widget.id) === 132975;
  }
  function variantQuantity(cart, id) {
    return cart && Array.isArray(cart.items) ? cart.items.reduce(function (sum, item) {
      return sum + (Number(item.variant_id || item.id) === id ? Number(item.quantity) || 0 : 0);
    }, 0) : 0;
  }
  function scheduleWidgetRefresh() {
    if (widgetRefreshTimer !== null || widgetRefreshRunning || widgetCartLeaving) return;
    widgetRefreshTimer = setTimeout(refreshWidgetCart, 300);
  }
  function refreshWidgetCart() {
    widgetRefreshTimer = null;
    var expected = pendingWidgetItems;
    pendingWidgetItems = {};
    var rebuy = window.Rebuy, sc = rebuy && rebuy.SmartCart;
    if (!Object.keys(expected).length) return;
    function containsExpected(cart) {
      return Object.keys(expected).every(function (id) {
        return variantQuantity(cart, Number(id)) >= expected[id];
      });
    }
    /* Let the normal observer win; healthy adds need no extra request. */
    if (rebuy && rebuy.Cart && sc && sc.status === 'ready' && containsExpected(rebuy.Cart.cart) && containsExpected(sc.cart)) return;
    var settled = false, timeout, releaseAutoOpen = sc ? suppressCartAutoOpen(sc) : function () {};
    activeWidgetItems = expected;
    widgetRefreshRunning = true;
    function finish(ok) {
      if (settled) return;
      settled = true;
      clearTimeout(timeout);
      widgetRefreshRunning = false;
      activeWidgetItems = {};
      if (!ok) {
        /* Keep auto-open suppressed until navigation disposes this document:
           the vendor may deliver its read callback after our timeout. */
        widgetCartLeaving = true;
        widgetNavigationRelease = releaseAutoOpen;
        window.location.assign(cartUrl());
        return;
      }
      releaseAutoOpen();
      if (Object.keys(pendingWidgetItems).length) scheduleWidgetRefresh();
    }
    timeout = setTimeout(function () { finish(false); }, 2500);
    try {
      rebuy.Cart.fetchShopifyCart(function () {
        if (settled) return;
        try {
          if (window.Rebuy !== rebuy || rebuy.SmartCart !== sc || !sc || sc.status !== 'ready' || !containsExpected(rebuy.Cart.cart)) { finish(false); return; }
          /* The vendor change event normally updates SmartCart synchronously. */
          if (!containsExpected(sc.cart) && typeof sc.setCart === 'function') sc.setCart(rebuy.Cart.cart);
          finish(containsExpected(sc.cart));
        } catch (error) { finish(false); }
      });
    } catch (error) { finish(false); }
  }
  document.addEventListener('rebuy.beforeAdd', function (event) {
    var detail = event.detail, product = detail && detail.product;
    if (!smartCartWidget(detail) || !product || Array.isArray(product)) return;
    var variant = product.selected_variant;
    var id = Number(variant && (product.subscription && variant.subscription_variant_id || variant.id));
    var quantity = Number(product.quantity);
    if (!Number.isSafeInteger(id) || id <= 0 || !Number.isSafeInteger(quantity) || quantity <= 0) return;
    var cart = window.Rebuy && window.Rebuy.Cart && window.Rebuy.Cart.cart;
    var baseline = Math.max(variantQuantity(cart, id), pendingWidgetItems[id] || 0, activeWidgetItems[id] || 0);
    widgetAddSnapshots.set(product, { id: id, quantity: quantity, target: baseline + quantity });
  });
  document.addEventListener('rebuy.add', function (event) {
    var detail = event.detail, product = detail && detail.product;
    if (!smartCartWidget(detail) || !product || Array.isArray(product)) return;
    var added = widgetAddSnapshots.get(product);
    if (!added) return;
    widgetAddSnapshots.delete(product);
    pendingWidgetItems[added.id] = Math.max(added.target, (pendingWidgetItems[added.id] || 0) + added.quantity);
    scheduleWidgetRefresh();
  });

  function effectiveAction(form, submitter) {
    var raw = (submitter && submitter.hasAttribute && submitter.hasAttribute('formaction'))
      ? submitter.getAttribute('formaction')
      : form.getAttribute('action');
    return new URL(raw || window.location.href, window.location.href);
  }
  function isCartAddForm(form, submitter) {
    var action;
    try { action = effectiveAction(form, submitter); } catch (e) { return false; }
    if (action.origin !== window.location.origin) return false;
    /* exact-path match against the locale-aware cart route — a suffix regex would also
       hijack /apps/<proxy>/cart/add and re-point ITS fields at the real cart endpoint */
    var real = new URL('cart/add', rootUrl()).pathname;
    var p = action.pathname.replace(/\/$/, '');
    return p === real || p === real + '.js';
  }
  function submitButtonFrom(target) {
    if (!target || target.nodeType !== 1) return null;
    var btn = target.closest('button, input');
    if (!btn) return null;
    var tag = btn.tagName.toLowerCase(), type = (btn.type || '').toLowerCase();
    if (tag === 'button' && type === 'submit') return btn;
    if (tag === 'input' && (type === 'submit' || type === 'image')) return btn;
    return null;
  }
  function shouldValidate(form, submitter) {
    return !form.noValidate && !(submitter && submitter.formNoValidate);
  }

  function clearError(form) {
    var el = form.querySelector('[data-wolf-cart-error]');
    if (el) { el.hidden = true; el.textContent = ''; }
  }
  function showError(form, message, ambiguous) {
    var el = form.querySelector('[data-wolf-cart-error]');
    if (!el) {
      el = document.createElement('div');
      el.setAttribute('data-wolf-cart-error', '');
      el.setAttribute('role', 'alert');
      el.setAttribute('tabindex', '-1');
      form.insertBefore(el, form.firstChild);
    }
    el.textContent = message;
    if (ambiguous) {
      el.appendChild(document.createTextNode(' '));
      var a = document.createElement('a');
      a.href = cartUrl(); a.textContent = 'Check your cart.';
      el.appendChild(a);
    }
    el.hidden = false;
    try { el.focus({ preventScroll: false }); } catch (e) { el.focus(); }
  }

  function lockForm(form, submitter) {
    lockedForms.add(form);
    form.setAttribute('aria-busy', 'true');
    form.setAttribute('data-wolf-adding', 'true');
    /* the sticky-bar submitter lives OUTSIDE the form — mark it directly so the
       pending style reaches whichever button was actually pressed (pass-2: the
       pending window read as a dead button to sighted users) */
    if (submitter && submitter.setAttribute) submitter.setAttribute('data-wolf-adding', 'true');
  }
  function releaseForm(form) {
    lockedForms.delete(form);
    form.removeAttribute('aria-busy');
    form.removeAttribute('data-wolf-adding');
    var marked = document.querySelectorAll('button[data-wolf-adding], input[data-wolf-adding]');
    /* scope to THIS form's submitters — a global unmark would strip the pending
       style off a second, still-locked form's sticky button (review pass-3) */
    for (var mi = 0; mi < marked.length; mi++) {
      if (marked[mi].form === form || form.contains(marked[mi])) marked[mi].removeAttribute('data-wolf-adding');
    }
  }

  function buildFormData(form, submitter) {
    var fd = new FormData(form);
    /* FormData(form) omits the activated submitter — preserve native semantics */
    if (submitter && submitter.name && !submitter.disabled) {
      var type = (submitter.type || '').toLowerCase();
      if (type === 'image') { fd.append(submitter.name + '.x', '0'); fd.append(submitter.name + '.y', '0'); }
      else fd.append(submitter.name, submitter.value || '');
    }
    return fd;
  }
  function shopifyError(payload, status) {
    if (payload) {
      if (typeof payload.description === 'string') return payload.description;
      if (typeof payload.message === 'string') return payload.message;
    }
    if (status === 422) return 'This item could not be added. It may be sold out or unavailable.';
    return 'This item could not be added to your cart.';
  }

  /* ---- add-to-cart analytics ----------------------------------------------
     We take ownership of the ATC click at document CAPTURE and stopPropagation()
     to stop a broken app extension (and to stop Rebuy double-adding), which means
     bubble-phase DOM-click trackers never see the click. So we emit the CART
     MUTATION instead of the attempted click, only after /cart/add.js confirms it:
       · GA4 ecommerce `add_to_cart` on window.dataLayer (GTM)
       · a bubbling+composed `theme:add_to_cart` CustomEvent for anything else
       · a Clarity timeline event, feature-detected only
     Navigation to /cart is HELD for GTM's eventCallback with an independent
     fallback timer, so a blocked/absent GTM can never strand the shopper.
     MEASURED 2026-08-07 (puppeteer, 2/2 runs, this store's real GTM container):
     `gtm.click-v2` with `gtm.triggers: "9"` STILL FIRES on the ATC button despite our
     stopPropagation — GTM registers its auto-event click listener at document CAPTURE,
     and stopPropagation does not suppress listeners on the SAME node. So click-triggered
     tags were never actually starved here.
     ⚠ OPERATOR / GTM OWNER — the risk is therefore DOUBLE-COUNTING, not loss: if GTM
     trigger 9 already fires a GA4 add_to_cart tag, and you also bind a Custom Event
     trigger to the `add_to_cart` event below, add_to_cart reports twice. Pick ONE:
     either keep the click trigger (this ecommerce payload is then just a richer,
     unused signal) or move to the Custom Event trigger and disable the click-fired
     ATC tag. A dataLayer event does NOT fire a Click trigger, so they are independent.
     Deliberately NOT calling fbq/ttq/gtag directly here — GTM likely maps them already
     and double-counting plus consent-bypass are worse than a missing duplicate. */
  function wolfAddedLines(payload) {
    if (!payload) return [];
    if (payload.items && Object.prototype.toString.call(payload.items) === '[object Array]') return payload.items;
    if (Object.prototype.toString.call(payload) === '[object Array]') return payload;
    return [payload];
  }
  function wolfCurrency() {
    var c = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || '';
    if (!c && window.wolfAnalytics) c = window.wolfAnalytics.currency || '';
    return String(c || '').toUpperCase();
  }
  function wolfEcommerce(lines) {
    var items = [], cents = 0, i, ln, qty, unit, vt, item;
    for (i = 0; i < lines.length; i++) {
      ln = lines[i] || {};
      qty = parseInt(ln.quantity, 10); if (!isFinite(qty) || qty < 1) qty = 1;
      /* final_price is the discounted unit price when Shopify supplies it */
      unit = Number(ln.final_price != null ? ln.final_price : (ln.discounted_price != null ? ln.discounted_price : ln.price));
      if (!isFinite(unit)) unit = 0;
      /* item_id = VARIANT id (always populated, identifies the purchasable unit).
         Switch to SKU only if GA4 + the product feed already use SKU throughout —
         never mix the two schemes. */
      item = {
        item_id: String(ln.variant_id || ln.id || ''),
        item_name: String(ln.product_title || ln.title || 'Product'),
        price: unit / 100,
        quantity: qty
      };
      if (window.wolfAnalytics && window.wolfAnalytics.shopName) item.affiliation = String(window.wolfAnalytics.shopName);
      if (ln.vendor) item.item_brand = String(ln.vendor);
      if (ln.product_type) item.item_category = String(ln.product_type);
      vt = ln.variant_title || '';
      if (vt && String(vt).toLowerCase() !== 'default title') item.item_variant = String(vt);
      items.push(item);
      cents += unit * qty;
    }
    return { currency: wolfCurrency(), value: Math.round(cents) / 100, items: items };
  }
  function wolfEmitAddToCart(form, payload, done) {
    var ec, navigated = false, timer;
    function go() {
      if (navigated) return;
      navigated = true;
      if (timer) clearTimeout(timer);
      /* brief delay so synchronous tag code can schedule its beacons before unload */
      setTimeout(done, 50);
    }
    try { ec = wolfEcommerce(wolfAddedLines(payload)); }
    catch (e) { done(); return; }
    /* independent of GTM: blocked, absent, or a stalled tag must not strand us */
    timer = setTimeout(go, 1500);
    try {
      var ev;
      if (typeof window.CustomEvent === 'function') {
        ev = new CustomEvent('theme:add_to_cart', { detail: { ecommerce: ec, source: 'theme-cart-add' }, bubbles: true, cancelable: false, composed: true });
      } else if (document.createEvent) {
        ev = document.createEvent('CustomEvent');
        ev.initCustomEvent('theme:add_to_cart', true, false, { ecommerce: ec, source: 'theme-cart-add' });
      }
      if (ev && form && form.dispatchEvent) form.dispatchEvent(ev);
    } catch (e) { /* analytics must never block the cart */ }
    try { if (typeof window.clarity === 'function') window.clarity('event', 'add_to_cart'); } catch (e) {}
    try {
      window.dataLayer = window.dataLayer || [];
      /* clear first so GTM's model can't merge stale items/value into this event */
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({ event: 'add_to_cart', ecommerce: ec, eventCallback: go, eventTimeout: 1200 });
    } catch (e) { /* fallback timer still navigates */ }
  }

  function addToCart(form, submitter) {
    if (lockedForms.has(form)) {
      /* not silent: if an outcome message is showing, re-announce it on every retry tap */
      var prior = form.querySelector('[data-wolf-cart-error]');
      if (prior && !prior.hidden) { try { prior.focus({ preventScroll: false }); } catch (e) { prior.focus(); } }
      return;
    }
    if (shouldValidate(form, submitter)) {
      if (typeof form.reportValidity === 'function' && !form.reportValidity()) return;
    }
    clearError(form);
    lockForm(form, submitter);
    /* native fallback is safe only when NO fetch was attempted */
    if (!window.fetch || !window.FormData) {
      HTMLFormElement.prototype.submit.call(form);
      return;
    }
    var fd;
    try { fd = buildFormData(form, submitter); }
    catch (e) {
      releaseForm(form);
      showError(form, 'The product form could not be prepared. Please reload the page and try again.', false);
      return;
    }
    var ctl = typeof AbortController === 'function' ? new AbortController() : null;
    if (ctl) setTimeout(function () { ctl.abort(); }, 12000);
    /* App wrappers may throw synchronously, including after starting a request.
       Route that ambiguous outcome through the same no-retry error handling. */
    Promise.resolve().then(function () {
      return fetch(cartAddUrl(), { method: 'POST', body: fd, credentials: 'same-origin', headers: { Accept: 'application/json' }, signal: ctl && ctl.signal });
    })
      .then(function (r) {
        /* 2xx WITH a JSON body = the add happened; a 2xx HTML page here is a
           bot-challenge/password interstitial the POST bounced off — indeterminate.
           Shopify serves /cart/add.js as `text/javascript` with a JSON body (live-
           verified), so accept json OR javascript — requiring literal `json` broke
           every add and the gate's new ATC probe caught it same-day. */
        if (r.ok && /json|javascript/.test(r.headers.get('content-type') || '')) {
          return r.text().then(function (t) {
            var payload = null;
            try { payload = t ? JSON.parse(t) : null; } catch (e) { payload = null; }
            /* emit analytics for the CONFIRMED mutation, then navigate */
            wolfEmitAddToCart(form, payload, function () {
              window.wolfOpenConfirmedCart(payload, function () { releaseForm(form); }, function () { window.location.assign(cartUrl()); });
            });
          });
        }
        if (r.ok) { var e2 = new Error('We could not confirm whether this item was added.'); e2.retrySafe = false; throw e2; }
        return r.text().then(function (text) {
          var payload = null;
          if (text) { try { payload = JSON.parse(text); } catch (e) { payload = null; } }
          var err = new Error(shopifyError(payload, r.status));
          /* 4xx = explicit rejection → retry-safe; 5xx/transport = indeterminate */
          err.retrySafe = r.status >= 400 && r.status < 500;
          throw err;
        });
      })
      .catch(function (err) {
        if (err && err.retrySafe) {
          releaseForm(form);
          showError(form, err.message || 'This item could not be added to your cart.', false);
          return;
        }
        /* indeterminate: stay locked (aria-busy stays on — the form IS inert) —
           a retry could duplicate an add that landed */
        showError(form, 'We could not confirm whether this item was added. Reload the page to try again.', true);
      });
  }

  document.addEventListener('click', function (e) {
    var submitter = submitButtonFrom(e.target);
    if (!submitter) return;
    var form = submitter.form || submitter.closest('form');
    if (!form || !isCartAddForm(form, submitter)) return;
    e.preventDefault();
    e.stopPropagation();
    addToCart(form, submitter);
  }, true);

  /* Enter-key implicit submission and form.requestSubmit() produce a submit
     event with no click; a canceled click never reaches submit, so the two
     handlers cannot both run for one gesture. */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.nodeType !== 1 || form.tagName.toLowerCase() !== 'form') return;
    var submitter = e.submitter || null;
    if (!isCartAddForm(form, submitter)) return;
    e.preventDefault();
    e.stopPropagation();
    addToCart(form, submitter);
  }, true);

  /* bfcache restore after a successful add must not leave forms locked */
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    lockedForms = new WeakSet();
    var stale = document.querySelectorAll('[data-wolf-adding]');
    for (var i = 0; i < stale.length; i++) {
      stale[i].removeAttribute('aria-busy');
      stale[i].removeAttribute('data-wolf-adding');
    }
  });
})();

/* Wolf homepage v2 (2026-09-03): 3D dialogs + reveal fallback */
(function(){
  try {
    document.querySelectorAll('[data-wolf-3d-open]').forEach(function(btn){
      btn.addEventListener('click', function(){
        var d = btn.closest('section').querySelector('[data-wolf-3d-dialog]');
        if(d && window.wolfArm3d) window.wolfArm3d(d.querySelector('model-viewer[data-glb]'));
        if(d && d.showModal) d.showModal();
      });
    });
    document.querySelectorAll('[data-wolf-3d-open2]').forEach(function(btn){
      btn.addEventListener('click', function(){
        var d = btn.closest('section').querySelector('[data-wolf-3d-dialog2]');
        if(d && window.wolfArm3d) window.wolfArm3d(d.querySelector('model-viewer[data-glb]'));
        if(d && d.showModal) d.showModal();
      });
    });
  } catch(e){}
})();
